import { useState, useEffect, useRef } from "react";
import { supabase } from "./supabaseClient";
import talebisLogo from "./talebis logo/talebis logo.jpeg";
const P="#7C3AED",PL="#EDE9FE",PM="#A78BFA",G="#10B981",OR="#F59E0B",RE="#EF4444",DK="#0F0A1E",GR="#6B7280",BG="#F8F7FF",GRN="#059669";
const ADMIN_KEY="talebis_admin_2024";
function useBP(){const[w,setW]=useState(typeof window!=="undefined"?window.innerWidth:375);useEffect(()=>{const f=()=>setW(window.innerWidth);window.addEventListener("resize",f);return()=>window.removeEventListener("resize",f);},[]);return{mob:w<640,tab:w<1024};}
function Logo({size=36}){return(<img src={talebisLogo} alt="Talebis" width={size} height={size} style={{borderRadius:"50%",objectFit:"cover",display:"block"}}/>);}
const btn=(bg,color,extra={})=>({background:bg,color,border:"none",borderRadius:10,fontWeight:700,fontSize:13,cursor:"pointer",...extra});
const card=(extra={})=>({background:"#fff",borderRadius:14,border:"1.5px solid #F0EDFF",...extra});
function XPBar({pct,color=P}){return(<div style={{height:10,background:PL,borderRadius:10,overflow:"hidden"}}><div style={{height:"100%",width:`${pct}%`,background:`linear-gradient(90deg,${color},${PM})`,borderRadius:10}}/></div>);}

const IconStudent=()=><svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/></svg>;
const IconEmployer=()=><svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/><line x1="12" y1="12" x2="12.01" y2="12"/></svg>;
const IconStartup=()=><svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"/><path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"/></svg>;

function LandingNav({onStudent,onEmployer,onStartup,onLogin}){
  const{mob}=useBP();const[open,setOpen]=useState(false);
  return(<>
    <nav style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:mob?"0 16px":"0 48px",height:68,background:"#fff",borderBottom:"1px solid #F0EDFF",position:"sticky",top:0,zIndex:100,boxShadow:"0 1px 12px rgba(124,58,237,0.07)"}}>
      <div style={{display:"flex",alignItems:"center",gap:10}}>
        <Logo size={38}/>
        <div><div style={{fontWeight:900,fontSize:18,color:DK,letterSpacing:"-0.5px",lineHeight:1}}>Talebis</div>{!mob&&<div style={{fontSize:10,color:GR,fontWeight:500,marginTop:2}}>Build Skills. Build Proof. Get Discovered.</div>}</div>
      </div>
      {!mob&&<div style={{display:"flex",gap:6}}>
        {["Features","How it Works","Pricing","Success Stories"].map(l=><span key={l} style={{color:GR,fontSize:14,fontWeight:500,cursor:"pointer",padding:"8px 12px",borderRadius:8}}>{l}</span>)}
      </div>}
      <div style={{display:"flex",gap:10,alignItems:"center"}}>
        {!mob&&<button onClick={onStartup} style={{...btn("none","#059669"),border:"1.5px solid #A7F3D0",padding:"8px 14px"}}>🚀 Startups</button>}
        {!mob&&<button onClick={onEmployer} style={{...btn("none",P),border:`1.5px solid ${PM}40`,padding:"8px 14px"}}>👔 Employers</button>}
        {!mob&&<button onClick={onLogin} style={{...btn("none",DK),fontSize:14}}>Log in</button>}
        <button onClick={onStudent} style={{background:`linear-gradient(135deg,${P},#5B21B6)`,color:"#fff",border:"none",borderRadius:10,padding:mob?"10px 16px":"11px 24px",fontWeight:700,fontSize:14,cursor:"pointer",boxShadow:`0 4px 16px ${P}50`}}>{mob?"Start Building":"Start Building Free "}</button>
        {mob&&<button onClick={()=>setOpen(o=>!o)} style={{...btn("none",DK),fontSize:22}}>☰</button>}
      </div>
    </nav>
    {mob&&open&&<div style={{background:"#fff",borderBottom:"1px solid #F0EDFF",padding:"12px 16px",position:"sticky",top:68,zIndex:99,display:"flex",flexDirection:"column",gap:10}}>
      {["Features","How it Works","Pricing","For Startups","For Employers"].map(l=><span key={l} onClick={()=>{setOpen(false);if(l==="For Startups")onStartup();if(l==="For Employers")onEmployer();}} style={{color:DK,fontSize:15,fontWeight:500,cursor:"pointer",padding:"4px 0"}}>{l}</span>)}
      <span onClick={()=>{setOpen(false);onLogin();}} style={{color:P,fontSize:15,fontWeight:600,cursor:"pointer"}}>Log in</span>
    </div>}
  </>);
}

function Hero({onStudent}){
  const{mob,tab}=useBP();
  return(<section style={{minHeight:mob?"auto":"88vh",display:"flex",alignItems:"center",flexDirection:tab?"column":"row",background:`radial-gradient(ellipse 80% 60% at 60% 40%,${PL} 0%,#fff 70%)`,padding:mob?"40px 16px":"0 48px",gap:48,overflow:"hidden"}}>
    <div style={{flex:1,maxWidth:540,textAlign:mob?"center":"left"}}>
      <div style={{display:"inline-flex",alignItems:"center",gap:6,background:PL,borderRadius:20,padding:"6px 14px",color:P,fontSize:12,fontWeight:600,marginBottom:20}}>✦ Nigeria's Career Experience Platform</div>
      <h1 style={{fontSize:mob?34:tab?44:54,fontWeight:900,lineHeight:1.08,color:DK,margin:"0 0 10px",letterSpacing:"-2px"}}>Turn Potential<br/>Into <span style={{color:P}}>Proof.</span></h1>
      <p style={{color:GR,fontSize:mob?15:17,lineHeight:1.7,marginBottom:10,fontWeight:500}}>A degree proves you studied.<br/>It doesn't prove you can do the job.</p>
      <p style={{color:DK,fontSize:mob?14:16,lineHeight:1.7,marginBottom:28}}>Build the experience employers are looking for -- before graduation. Real projects, AI guidance, verified portfolio, employer discovery.</p>
      <div style={{display:"flex",gap:12,flexWrap:"wrap",justifyContent:mob?"center":"flex-start",marginBottom:24}}>
        <button onClick={onStudent} style={{background:`linear-gradient(135deg,${P},#5B21B6)`,color:"#fff",border:"none",borderRadius:12,padding:"14px 28px",fontWeight:700,fontSize:15,cursor:"pointer",boxShadow:`0 4px 20px ${P}40`}}>Start Building Free →</button>
        <button style={{...btn("#fff",DK),border:"1.5px solid #E5E0FF",padding:"14px 20px",fontSize:14}}>▶ Watch Demo</button>
      </div>
      <div style={{display:"flex",alignItems:"center",gap:10,justifyContent:mob?"center":"flex-start"}}>
        <div style={{display:"flex"}}>{["#7C3AED","#10B981","#F59E0B","#EF4444"].map((c,i)=><div key={i} style={{width:26,height:26,borderRadius:"50%",background:c,border:"2px solid #fff",marginLeft:i>0?-8:0}}/>)}</div>
        <span style={{color:GR,fontSize:13}}>Be among the first to build the future with Talebis.</span>
      </div>
    </div>
    {!mob&&<div style={{flex:1,position:"relative",height:360,maxWidth:400}}>
      <div style={{position:"absolute",left:0,top:20,width:240,height:300,background:`linear-gradient(135deg,${P}20,${PL})`,borderRadius:24,display:"flex",alignItems:"center",justifyContent:"center",fontSize:72}}>👨🏾‍💻</div>
      <div style={{position:"absolute",top:10,right:20,width:180,background:"#fff",borderRadius:14,padding:14,boxShadow:"0 8px 32px rgba(124,58,237,0.12)",border:"1px solid #F0EDFF"}}>
        <div style={{fontSize:12,color:GR}}>Projects Built</div>
        <div style={{fontSize:26,fontWeight:900,color:DK}}>24 <span style={{fontSize:13,color:G}}>+60%</span></div>
      </div>
      <div style={{position:"absolute",top:160,right:0,width:160,background:"#fff",borderRadius:14,padding:14,boxShadow:"0 8px 32px rgba(124,58,237,0.12)",border:"1px solid #F0EDFF",textAlign:"center"}}>
        <div style={{fontSize:12,color:GR,marginBottom:4}}>Career Score</div>
        <div style={{fontSize:32,fontWeight:900,color:P}}>85%</div>
        <div style={{fontSize:11,color:G}}>Excellent</div>
      </div>
    </div>}
    {mob&&<div style={{width:"100%",height:160,background:`linear-gradient(135deg,${P}20,${PL})`,borderRadius:20,display:"flex",alignItems:"center",justifyContent:"center",fontSize:64}}>👨🏾‍💻</div>}
  </section>);
}

function PortalSelector({onStudent,onEmployer,onStartup}){
  const{mob}=useBP();
  const portals=[
    {accent:P,iconBg:PL,accentBorder:`${P}25`,Icon:IconStudent,tag:"FOR STUDENTS",title:"Build Experience Before You Graduate",desc:"Learn in-demand skills, work on real projects with AI guidance, build a verified portfolio, and get discovered by employers -- before you need a job.",feats:["Learn · Practice · Build · Get Verified","AI-powered career mentorship","Verified portfolio employers can see","Employer discovery & job board"],action:onStudent,cta:"Start Building Free "},
    {accent:"#1D4ED8",iconBg:"#EFF6FF",accentBorder:"#BFDBFE",Icon:IconEmployer,tag:"FOR EMPLOYERS",title:"Hire Talent With Proof.",desc:"Stop judging graduates by CVs alone. Discover students who have demonstrated their skills through real projects, verified portfolios and assessments.",feats:["Discover · Assess · Shortlist · Hire","Browse verified skill portfolios","Review real project work","Talent analytics & scoring"],action:onEmployer,cta:"Find Proven Talent "},
    {accent:GRN,iconBg:"#ECFDF5",accentBorder:"#A7F3D0",Icon:IconStartup,tag:"FOR FOUNDERS",title:"Build Your Business",desc:"Turn your idea into a real business. Learn · Validate · Build · Get Mentored · Find Opportunities. Access funding, co-founders and AI advice.",feats:["Learn · Validate · Build · Grow","AI startup advisor & mentorship","Co-founder matching & team builder","Funding opportunities hub"],action:onStartup,cta:"Build Your Startup "},
  ];
  return(<section style={{padding:mob?"40px 16px":"72px 48px",background:"#fff",borderTop:"1px solid #F0EDFF"}}>
    <div style={{textAlign:"center",marginBottom:mob?32:48,maxWidth:680,margin:"0 auto 40px"}}>
      <div style={{display:"inline-flex",alignItems:"center",gap:6,background:PL,borderRadius:20,padding:"5px 14px",color:P,fontSize:11,fontWeight:700,letterSpacing:1,textTransform:"uppercase",marginBottom:16}}>One Ecosystem. Three Portals.</div>
      <h2 style={{fontSize:mob?24:38,fontWeight:900,color:DK,margin:"0 0 14px",letterSpacing:"-1px",lineHeight:1.1}}>Choose Your Talebis Experience</h2>
      <p style={{color:GR,fontSize:mob?14:16,margin:0,lineHeight:1.7}}>Whether you're building your career, hiring talent, or building a startup -- Talebis gives you the tools to move forward.</p>
    </div>
    <div style={{display:"grid",gridTemplateColumns:mob?"1fr":"repeat(3,1fr)",gap:mob?14:24,maxWidth:1080,margin:"0 auto"}}>
      {portals.map((p,i)=>{const PortalIcon=p.Icon;return(
        <div key={i} style={{background:"#fff",borderRadius:20,padding:mob?"18px":"28px 24px",border:`1.5px solid ${p.accentBorder}`,display:"flex",flexDirection:"column",boxShadow:"0 4px 24px rgba(0,0,0,0.06)",transition:"transform 0.2s,box-shadow 0.2s"}}
          onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-4px)";e.currentTarget.style.boxShadow=`0 12px 40px ${p.accent}25`;}}
          onMouseLeave={e=>{e.currentTarget.style.transform="none";e.currentTarget.style.boxShadow="0 4px 24px rgba(0,0,0,0.06)";}}>
          <div style={{fontSize:10,fontWeight:800,color:p.accent,letterSpacing:1.5,textTransform:"uppercase",marginBottom:14}}>{p.tag}</div>
          <div style={{width:52,height:52,borderRadius:14,background:p.iconBg,display:"flex",alignItems:"center",justifyContent:"center",color:p.accent,marginBottom:14}}><PortalIcon/></div>
          <div style={{fontWeight:800,fontSize:mob?17:20,color:DK,marginBottom:8,letterSpacing:"-0.5px"}}>{p.title}</div>
          <div style={{fontSize:13,color:GR,marginBottom:18,lineHeight:1.65,flex:1}}>{p.desc}</div>
          {!mob&&<div style={{display:"flex",flexDirection:"column",gap:8,marginBottom:22}}>
            {p.feats.map((f,j)=><div key={j} style={{display:"flex",alignItems:"center",gap:10,fontSize:13,color:DK}}>
              <div style={{width:18,height:18,borderRadius:"50%",background:p.iconBg,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                <svg width="10" height="10" viewBox="0 0 12 12" fill="none"><path d="M2 6l3 3 5-5" stroke={p.accent} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </div>{f}</div>)}
          </div>}
          <button onClick={p.action} style={{background:p.accent,color:"#fff",border:"none",borderRadius:12,padding:"13px",fontWeight:700,fontSize:14,cursor:"pointer",width:"100%",boxShadow:`0 4px 16px ${p.accent}40`}}>{p.cta} →</button>
        </div>
      );})}
    </div>
  </section>);
}


function ProblemSection(){
  const{mob}=useBP();
  return(<section style={{padding:mob?"48px 16px":"72px 48px",background:DK}}>
    <div style={{textAlign:"center",marginBottom:mob?32:48}}>
      <div style={{fontSize:mob?24:36,fontWeight:900,color:"#fff",marginBottom:12,letterSpacing:"-1px"}}>A degree proves you studied.<br/><span style={{color:PM}}>It doesn't prove you can do the job.</span></div>
      <p style={{color:"#9CA3AF",fontSize:mob?14:16,maxWidth:560,margin:"0 auto"}}>Most Nigerian graduates face the same wall: employers want experience, but no one gave them the chance to get it.</p>
    </div>
    <div style={{display:"grid",gridTemplateColumns:mob?"1fr":"1fr 1fr",gap:20,maxWidth:860,margin:"0 auto"}}>
      <div style={{background:"rgba(239,68,68,0.1)",border:"1.5px solid rgba(239,68,68,0.2)",borderRadius:20,padding:28}}>
        <div style={{fontSize:14,fontWeight:800,color:"#FCA5A5",letterSpacing:1,marginBottom:20}}>WITHOUT TALEBIS</div>
        {["Degree · No experience","Weak CV · Job applications","Rejections · Frustration","You need experience first"].map((s,i)=><div key={i} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 0",borderBottom:i<3?"1px solid rgba(255,255,255,0.06)":"none"}}>
          <div style={{width:22,height:22,borderRadius:"50%",background:"rgba(239,68,68,0.2)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}><span style={{color:RE,fontSize:12}}>✕</span></div>
          <span style={{fontSize:14,color:"#D1D5DB"}}>{s}</span>
        </div>)}
      </div>
      <div style={{background:"rgba(16,185,129,0.1)",border:"1.5px solid rgba(16,185,129,0.2)",borderRadius:20,padding:28}}>
        <div style={{fontSize:14,fontWeight:800,color:"#6EE7B7",letterSpacing:1,marginBottom:20}}>WITH TALEBIS</div>
        {["Learn · Build real projects","Prove skills with a verified portfolio","Get discovered by employers","Land opportunities before graduation"].map((s,i)=><div key={i} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 0",borderBottom:i<3?"1px solid rgba(255,255,255,0.06)":"none"}}>
          <div style={{width:22,height:22,borderRadius:"50%",background:"rgba(16,185,129,0.2)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}><span style={{color:G,fontSize:12}}>✓</span></div>
          <span style={{fontSize:14,color:"#D1D5DB"}}>{s}</span>
        </div>)}
      </div>
    </div>
  </section>);
}

function HowItWorks({onStudent}){
  const{mob}=useBP();
  const steps=[
    {num:"01",icon:"🔍",title:"Discover",desc:"Find the exact skills employers are hiring for right now in Nigeria and across Africa."},
    {num:"02",icon:"🤖",title:"Learn",desc:"Study with AI-powered mentorship that guides you based on your goals and pace."},
    {num:"03",icon:"🏗️",title:"Build",desc:"Complete real-world projects that demonstrate what you can actually do."},
    {num:"04",icon:"✅",title:"Prove",desc:"Build a verified portfolio with your completed projects, skill scores and assessments."},
    {num:"05",icon:"🚀",title:"Get Discovered",desc:"Employers and opportunities find you based on your proven abilities -- not just your degree."},
  ];
  return(<section style={{padding:mob?"48px 16px":"80px 48px",background:BG}}>
    <div style={{textAlign:"center",marginBottom:mob?40:56}}>
      <div style={{display:"inline-flex",alignItems:"center",gap:6,background:PL,borderRadius:20,padding:"5px 14px",color:P,fontSize:11,fontWeight:700,letterSpacing:1,textTransform:"uppercase",marginBottom:14}}>The Talebis Journey</div>
      <h2 style={{fontSize:mob?26:38,fontWeight:900,color:DK,margin:"0 0 12px",letterSpacing:"-1px"}}>From Student to Opportunity</h2>
      <p style={{color:GR,fontSize:mob?14:16,margin:0}}>Every step is designed to get you closer to real opportunities.</p>
    </div>
    <div style={{display:"flex",flexDirection:"column",gap:0,maxWidth:700,margin:"0 auto 40px"}}>
      {steps.map((s,i)=><div key={i} style={{display:"flex",gap:20,alignItems:"flex-start",position:"relative"}}>
        <div style={{display:"flex",flexDirection:"column",alignItems:"center",flexShrink:0}}>
          <div style={{width:52,height:52,borderRadius:"50%",background:P,display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,flexShrink:0,boxShadow:`0 4px 16px ${P}40`}}>{s.icon}</div>
          {i<steps.length-1&&<div style={{width:2,height:40,background:`linear-gradient(${P},${PL})`,margin:"4px 0"}}/>}
        </div>
        <div style={{paddingBottom:i<steps.length-1?24:0,paddingTop:12}}>
          <div style={{fontSize:10,fontWeight:800,color:P,letterSpacing:2,marginBottom:4}}>{s.num}</div>
          <div style={{fontWeight:800,fontSize:17,color:DK,marginBottom:6}}>{s.title}</div>
          <div style={{fontSize:14,color:GR,lineHeight:1.6}}>{s.desc}</div>
        </div>
      </div>)}
    </div>
    <div style={{textAlign:"center"}}>
      <button onClick={onStudent} style={{background:`linear-gradient(135deg,${P},#5B21B6)`,color:"#fff",border:"none",borderRadius:12,padding:"14px 32px",fontWeight:700,fontSize:15,cursor:"pointer",boxShadow:`0 4px 20px ${P}40`}}>Start Building Your Career →</button>
    </div>
  </section>);
}

function StudentProofSection({onStudent}){
  const{mob}=useBP();
  return(<section style={{padding:mob?"48px 16px":"80px 48px",background:"#fff"}}>
    <div style={{textAlign:"center",marginBottom:mob?36:52}}>
      <div style={{display:"inline-flex",alignItems:"center",gap:6,background:PL,borderRadius:20,padding:"5px 14px",color:P,fontSize:11,fontWeight:700,letterSpacing:1,textTransform:"uppercase",marginBottom:14}}>Real Student Profiles</div>
      <h2 style={{fontSize:mob?24:36,fontWeight:900,color:DK,margin:"0 0 12px",letterSpacing:"-1px"}}>Don't Just Tell Employers<br/>What You Can Do. <span style={{color:P}}>Show Them.</span></h2>
      <p style={{color:GR,fontSize:mob?14:16,margin:0}}>Every Talebis student gets a verified profile employers can actually assess.</p>
    </div>
    <div style={{display:"grid",gridTemplateColumns:mob?"1fr":"1fr 1fr",gap:mob?20:32,maxWidth:900,margin:"0 auto 40px",alignItems:"center"}}>
      <div style={{background:`linear-gradient(135deg,${DK},#1e0a4e)`,borderRadius:20,padding:28,boxShadow:"0 16px 48px rgba(124,58,237,0.2)"}}>
        <div style={{display:"flex",alignItems:"center",gap:14,marginBottom:22}}>
          <div style={{width:52,height:52,borderRadius:"50%",background:`linear-gradient(135deg,${P},${PM})`,display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontWeight:900,fontSize:18,flexShrink:0}}>AO</div>
          <div><div style={{fontWeight:800,fontSize:17,color:"#fff"}}>Adaeze Okonkwo</div><div style={{fontSize:12,color:"#C4B5FD"}}>Product Design & Business · Lagos</div><div style={{display:"inline-flex",alignItems:"center",gap:4,background:"rgba(16,185,129,0.2)",borderRadius:20,padding:"2px 10px",marginTop:4}}><span style={{color:G,fontSize:9,fontWeight:700}}>✓ VERIFIED PROFILE</span></div></div>
        </div>
        <div style={{marginBottom:18}}>
          <div style={{fontSize:11,fontWeight:700,color:"#9CA3AF",letterSpacing:1,marginBottom:10}}>VERIFIED SKILLS</div>
          <div style={{display:"flex",flexWrap:"wrap",gap:8}}>{["UI/UX Design","Product Strategy","AI Tools","Business Dev","Figma","User Research"].map(s=><span key={s} style={{fontSize:11,fontWeight:600,color:PM,background:"rgba(167,139,250,0.15)",borderRadius:20,padding:"4px 12px"}}>{s}</span>)}</div>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:12,marginBottom:20}}>
          {[["8","Projects Built"],["12","Skills Verified"],["87%","Career Score"]].map(([v,l])=><div key={l} style={{background:"rgba(255,255,255,0.07)",borderRadius:12,padding:"12px 8px",textAlign:"center"}}><div style={{fontWeight:900,fontSize:22,color:"#fff"}}>{v}</div><div style={{fontSize:10,color:"#9CA3AF",marginTop:2}}>{l}</div></div>)}
        </div>
        <button onClick={onStudent} style={{width:"100%",background:`linear-gradient(135deg,${P},#5B21B6)`,color:"#fff",border:"none",borderRadius:12,padding:"12px",fontWeight:700,fontSize:14,cursor:"pointer"}}>View Portfolio →</button>
      </div>
      <div style={{display:"flex",flexDirection:"column",gap:20}}>
        {[{icon:"📁",title:"Verified Portfolio",desc:"Every project you complete is added to your portfolio. Employers see real work, not just a CV."},
          {icon:"⭐",title:"Skill Score",desc:"Your career readiness score shows employers how prepared you are -- based on actual skills and projects."},
          {icon:"🔍",title:"Employer Discovery",desc:"Employers search for talent using skills, scores and portfolios. The best profiles get found."}
        ].map((f,i)=><div key={i} style={{display:"flex",gap:14,alignItems:"flex-start"}}>
          <div style={{width:44,height:44,borderRadius:12,background:PL,display:"flex",alignItems:"center",justifyContent:"center",fontSize:20,flexShrink:0}}>{f.icon}</div>
          <div><div style={{fontWeight:700,fontSize:15,color:DK,marginBottom:4}}>{f.title}</div><div style={{fontSize:13,color:GR,lineHeight:1.6}}>{f.desc}</div></div>
        </div>)}
      </div>
    </div>
  </section>);
}

function EmployerSection({onEmployer}){
  const{mob}=useBP();
  return(<section style={{padding:mob?"48px 16px":"80px 48px",background:BG,borderTop:"1px solid #F0EDFF"}}>
    <div style={{maxWidth:1000,margin:"0 auto",display:"grid",gridTemplateColumns:mob?"1fr":"1fr 1fr",gap:mob?32:60,alignItems:"center"}}>
      <div>
        <div style={{display:"inline-flex",alignItems:"center",gap:6,background:"#EFF6FF",borderRadius:20,padding:"5px 14px",color:"#1D4ED8",fontSize:11,fontWeight:700,letterSpacing:1,textTransform:"uppercase",marginBottom:16}}>For Employers</div>
        <h2 style={{fontSize:mob?26:38,fontWeight:900,color:DK,margin:"0 0 14px",letterSpacing:"-1px"}}>Hire Talent<br/><span style={{color:"#1D4ED8"}}>With Proof.</span></h2>
        <p style={{color:GR,fontSize:mob?14:16,lineHeight:1.7,marginBottom:24}}>Stop judging graduates by CVs alone. Discover students who have demonstrated their abilities through real-world projects, verified portfolios and skill assessments.</p>
        <div style={{display:"flex",flexDirection:"column",gap:14,marginBottom:28}}>
          {[["🔍","Discover","Find candidates by skill, score and project type -- not just degree."],["📁","Assess","Review actual project portfolios and verified skill scores before the interview."],["⚡","Shortlist","Save time. Only interview candidates who've already proven they can do the job."]].map(([ic,t,d])=><div key={t} style={{display:"flex",gap:14,alignItems:"flex-start"}}>
            <div style={{width:38,height:38,borderRadius:10,background:"#EFF6FF",display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,flexShrink:0}}>{ic}</div>
            <div><div style={{fontWeight:700,fontSize:14,color:DK,marginBottom:2}}>{t}</div><div style={{fontSize:13,color:GR}}>{d}</div></div>
          </div>)}
        </div>
        <button onClick={onEmployer} style={{background:"#1D4ED8",color:"#fff",border:"none",borderRadius:12,padding:"13px 28px",fontWeight:700,fontSize:15,cursor:"pointer",boxShadow:"0 4px 20px rgba(29,78,216,0.3)"}}>Find Verified Talent →</button>
      </div>
      <div style={{display:"flex",flexDirection:"column",gap:12}}>
        {[{score:97,name:"Ngozi Adeleke",role:"Frontend Dev",skills:["React","TypeScript","GraphQL"],badge:"Top 1%"},
          {score:91,name:"Fatima Bello",role:"Backend Dev",skills:["Node.js","MongoDB","Express"],badge:"Verified"},
          {score:88,name:"Emeka Nwosu",role:"UI/UX Designer",skills:["Figma","UX Research","CSS"],badge:"Verified"}
        ].map((c,i)=><div key={i} style={{background:"#fff",borderRadius:14,padding:"14px 18px",border:"1.5px solid #E5E7EB",display:"flex",alignItems:"center",gap:14}}>
          <div style={{width:40,height:40,borderRadius:"50%",background:`linear-gradient(135deg,${P},${PM})`,display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontWeight:700,fontSize:13,flexShrink:0}}>{c.name[0]}{c.name.split(" ")[1][0]}</div>
          <div style={{flex:1,minWidth:0}}><div style={{fontWeight:700,fontSize:13,color:DK}}>{c.name}</div><div style={{fontSize:11,color:GR,marginBottom:4}}>{c.role}</div><div style={{display:"flex",gap:4,flexWrap:"wrap"}}>{c.skills.slice(0,2).map(s=><span key={s} style={{fontSize:10,fontWeight:600,color:P,background:PL,borderRadius:10,padding:"1px 6px"}}>{s}</span>)}</div></div>
          <div style={{textAlign:"right",flexShrink:0}}><div style={{fontWeight:900,fontSize:18,color:c.score>=95?G:P}}>{c.score}%</div><div style={{fontSize:9,fontWeight:700,color:G,background:"#ECFDF5",borderRadius:10,padding:"2px 6px"}}>{c.badge}</div></div>
        </div>)}
        <div style={{textAlign:"center",fontSize:12,color:GR,padding:"8px 0"}}>Discover · Assess · Shortlist · Hire</div>
      </div>
    </div>
  </section>);
}

function JourneyStrip(){
  const{mob}=useBP();
  const steps=[{icon:"📚",label:"LEARN"},{icon:"🏗️",label:"BUILD"},{icon:"✅",label:"PROVE"},{icon:"🔍",label:"DISCOVER"},{icon:"💼",label:"WORK"},{icon:"🚀",label:"STARTUP"}];
  return(<section style={{background:DK,padding:mob?"24px 16px":"32px 48px"}}>
    <div style={{textAlign:"center",marginBottom:20}}><div style={{fontSize:10,fontWeight:700,color:PM,letterSpacing:2,textTransform:"uppercase"}}>The Talebis Journey</div></div>
    <div style={{display:"flex",alignItems:"center",justifyContent:"center",flexWrap:mob?"wrap":"nowrap",maxWidth:900,margin:"0 auto",gap:0}}>
      {steps.map((s,i)=><div key={i} style={{display:"flex",alignItems:"center"}}>
        <div style={{textAlign:"center",padding:mob?"8px 10px":"0 16px"}}>
          <div style={{fontSize:mob?18:22,marginBottom:4}}>{s.icon}</div>
          <div style={{fontSize:9,fontWeight:800,color:"#fff",letterSpacing:1}}>{s.label}</div>
        </div>
        {i<steps.length-1&&!mob&&<div style={{color:PM,fontSize:16,opacity:0.5}}>›</div>}
      </div>)}
    </div>
  </section>);
}

function Features(){
  const{mob}=useBP();
  const feats=[{i:"🤖",t:"AI Mentor",d:"Personalized guidance 24/7"},{i:"🏗️",t:"Real Projects",d:"Industry-ready portfolio"},{i:"🏆",t:"Gamification",d:"XP, badges & leaderboards"},{i:"📁",t:"Portfolio Builder",d:"Showcase your skills"},{i:"💼",t:"Career Hub",d:"Jobs & internships"}];
  return(<section style={{padding:mob?"48px 16px":"72px 48px",background:BG}}>
    <div style={{textAlign:"center",marginBottom:36}}>
      <div style={{color:GR,fontSize:14,marginBottom:8}}>Everything you need to</div>
      <h2 style={{fontSize:mob?26:34,fontWeight:900,color:DK,margin:0}}>grow <span style={{color:P}}>your career</span></h2>
    </div>
    <div style={{display:"grid",gridTemplateColumns:mob?"1fr 1fr":"repeat(5,1fr)",gap:mob?10:14}}>
      {feats.map(f=><div key={f.t} style={{...card({padding:"20px 16px",textAlign:"center"})}}><div style={{fontSize:28,marginBottom:10}}>{f.i}</div><div style={{fontWeight:700,fontSize:14,color:DK,marginBottom:6}}>{f.t}</div><div style={{fontSize:12,color:GR}}>{f.d}</div></div>)}
    </div>
  </section>);
}

function Pricing({onUpgrade}){
  const{mob}=useBP();
  return(<section style={{padding:mob?"48px 16px":"72px 48px",background:"#fff"}}>
    <div style={{textAlign:"center",marginBottom:40}}>
      <div style={{fontSize:12,fontWeight:600,color:P,letterSpacing:1,textTransform:"uppercase",marginBottom:8}}>Pricing</div>
      <h2 style={{fontSize:mob?26:36,fontWeight:900,color:DK,margin:"0 0 8px"}}>Simple, honest pricing</h2>
      <p style={{color:GR,margin:0}}>Start free. Upgrade when you're ready.</p>
    </div>
    <div style={{display:"grid",gridTemplateColumns:mob?"1fr":"1fr 1fr",gap:20,maxWidth:780,margin:"0 auto"}}>
      {[{label:"FREE",price:"₦0",sub:"Perfect for getting started",bg:"#fff",border:"#E5E7EB",titleC:GR,priceC:DK,textC:DK,subC:GR,feats:["3 AI Mentor sessions/day","20 starter projects","Basic portfolio","Community access"],btnBg:BG,btnColor:DK,cta:"Get Started Free",action:null},
        {label:"PREMIUM",price:"₦3000",sub:"For serious career builders",bg:DK,border:"none",titleC:"#C4B5FD",priceC:"#fff",textC:"#fff",subC:"#C4B5FD",feats:["Unlimited AI Mentor","All 200+ projects","Verified portfolio badge","Full job board"],btnBg:P,btnColor:"#fff",cta:"Upgrade to Premium 👑",action:onUpgrade,popular:true}
      ].map((pl,i)=><div key={i} style={{background:pl.bg,borderRadius:20,padding:28,border:`1.5px solid ${pl.border}`,position:"relative",overflow:"hidden"}}>
        {pl.popular&&<div style={{position:"absolute",top:0,right:0,background:OR,color:"#fff",fontSize:11,fontWeight:700,padding:"6px 14px",borderRadius:"0 20px 0 12px"}}>Most Popular</div>}
        <div style={{fontSize:12,fontWeight:700,color:pl.titleC,marginBottom:6}}>{pl.label}</div>
        <div style={{display:"flex",alignItems:"baseline",gap:4,marginBottom:4}}><span style={{fontSize:38,fontWeight:900,color:pl.priceC}}>{pl.price}</span><span style={{fontSize:13,color:pl.subC}}>/month</span></div>
        <div style={{fontSize:13,color:pl.subC,marginBottom:20}}>{pl.sub}</div>
        <div style={{marginBottom:24}}>{pl.feats.map((f,j)=><div key={j} style={{display:"flex",alignItems:"center",gap:10,padding:"7px 0",borderBottom:j<pl.feats.length-1?`1px solid ${i===1?"rgba(255,255,255,0.08)":"#F8F7FF"}`:"none"}}>
          <div style={{width:18,height:18,borderRadius:"50%",background:G,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}><span style={{color:"#fff",fontSize:10,fontWeight:700}}>✓</span></div>
          <span style={{fontSize:13,color:pl.textC}}>{f}</span>
        </div>)}</div>
        <button onClick={pl.action||onUpgrade} style={{...btn(pl.btnBg,pl.btnColor),width:"100%",padding:"13px"}}>{pl.cta}</button>
        {pl.popular&&<div style={{textAlign:"center",fontSize:11,color:"#9CA3AF",marginTop:8}}>Cancel anytime · No hidden fees</div>}
      </div>)}
    </div>
  </section>);
}

function Trusted(){
  const{mob}=useBP();
  return(<section style={{padding:mob?"28px 16px":"40px 48px",background:BG,borderTop:"1px solid #F0EDFF"}}>
    <div style={{textAlign:"center",marginBottom:18,fontSize:11,fontWeight:600,color:GR,letterSpacing:1,textTransform:"uppercase"}}>Used by students from these schools & more</div>
    <div style={{display:"flex",flexWrap:"wrap",gap:10,justifyContent:"center"}}>
      {["UNILAG","Covenant University","Babcock University","University of Ibadan","Ahmadu Bello","Landmark University","LASU","Yaba Tech"].map(s=><div key={s} style={{fontSize:12,fontWeight:600,color:GR,padding:"5px 12px",borderRadius:20,background:"#fff",border:"1px solid #F0EDFF"}}>{s}</div>)}
    </div>
  </section>);
}

function CTA({onStudent}){
  const{mob}=useBP();const[email,setEmail]=useState("");
  return(<section style={{background:`linear-gradient(135deg,${DK},#2D1B6B)`,padding:mob?"56px 16px":"72px 48px",textAlign:"center"}}>
    <p style={{fontSize:mob?13:14,color:PM,fontWeight:700,letterSpacing:1,textTransform:"uppercase",marginBottom:12}}>Your degree is the beginning.</p>
    <h2 style={{fontSize:mob?28:40,fontWeight:900,color:"#fff",marginBottom:8,letterSpacing:"-1px"}}>Your skills are your future.</h2>
    <p style={{color:"#C4B5FD",marginBottom:28,fontSize:mob?14:16}}>Start building real experience today. Join students across Nigeria using Talebis to prove what they can do.</p>
    <div style={{display:"flex",gap:10,justifyContent:"center",flexDirection:mob?"column":"row",maxWidth:420,margin:"0 auto 16px"}}>
      <input value={email} onChange={e=>setEmail(e.target.value)} placeholder="Enter your email address" style={{flex:1,padding:"12px 16px",borderRadius:12,border:"1.5px solid #4C1D95",background:"rgba(255,255,255,0.08)",color:"#fff",fontSize:14,outline:"none"}}/>
      <button onClick={onStudent} style={{background:`linear-gradient(135deg,${P},#5B21B6)`,color:"#fff",border:"none",borderRadius:12,padding:"13px 28px",fontWeight:700,fontSize:15,cursor:"pointer",boxShadow:`0 4px 20px ${P}40`}}>Start Building With Talebis →</button>
    </div>
  </section>);
}

function AuthModal({onClose,onSuccess,defaultTab="login"}){
  const{mob}=useBP();const[tab,setTab]=useState(defaultTab);const[portal,setPortal]=useState("student");
  const[form,setForm]=useState({name:"",email:"",password:""});const[loading,setLoading]=useState(false);const[error,setError]=useState("");const[done,setDone]=useState(false);
  const portals=[{value:"student",icon:"🎓",label:"Student",desc:"Learn & get discovered"},{value:"employer",icon:"👔",label:"Employer",desc:"Hire verified talent"},{value:"startup",icon:"🚀",label:"Startup / Founder",desc:"Build your product"}];
  function upd(k,v){setForm(f=>({...f,[k]:v}));setError("");}
  async function submit(){
    if(!form.email||!form.password){setError("Email and password are required.");return;}
    if(tab==="signup"&&!form.name){setError("Please enter your name.");return;}
    setLoading(true);setError("");
    try{
      if(tab==="signup"){
        const{data,error:signUpError}=await supabase.auth.signUp({email:form.email,password:form.password});
        if(signUpError)throw signUpError;
        const uid=data.user?.id;
        if(uid){
          const{error:insertError}=await supabase.from("profiles").insert({id:uid,name:form.name,email:form.email,portal});
          if(insertError)console.error("Profile creation error:",insertError.message);
        }
        setLoading(false);setDone(true);
        setTimeout(()=>{onSuccess({portal,name:form.name,email:form.email,profile:{id:uid,name:form.name,email:form.email,portal,plan:"free"}});onClose();},1000);
      }else{
        const{data,error:signInError}=await supabase.auth.signInWithPassword({email:form.email,password:form.password});
        if(signInError)throw signInError;
        const uid=data.user?.id;
        let profile=null;
        if(uid){
          const{data:profileData}=await supabase.from("profiles").select("*").eq("id",uid).single();
          profile=profileData;
        }
        const finalProfile={...profile,id:profile?.id||uid};
        setLoading(false);setDone(true);
        setTimeout(()=>{onSuccess({portal:finalProfile.portal||"student",name:finalProfile.name||form.email.split("@")[0],email:form.email,profile:finalProfile});onClose();},1000);
      }
    }catch(err){
      setLoading(false);
      setError(err.message||"Something went wrong. Please try again.");
    }
  }
  const inp={width:"100%",padding:"11px 14px",borderRadius:10,border:"1.5px solid #E0D9FF",fontSize:14,outline:"none",color:DK,boxSizing:"border-box",marginBottom:12,background:"#fff"};
  return(<div style={{position:"fixed",inset:0,background:"rgba(15,10,30,0.75)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:600,padding:16}}>
    <div style={{background:"#fff",borderRadius:20,padding:mob?22:36,width:"100%",maxWidth:460,position:"relative",boxShadow:`0 24px 64px ${P}30`,maxHeight:"90vh",overflowY:"auto"}}>
      <button onClick={onClose} style={{position:"absolute",top:14,right:14,background:PL,border:"none",borderRadius:"50%",width:32,height:32,cursor:"pointer",fontSize:15,color:GR}}>✕</button>
      <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:20}}><Logo size={34}/><span style={{fontWeight:800,fontSize:18,color:DK}}>Talebis</span></div>
      {done?(<div style={{textAlign:"center",padding:"24px 0"}}><div style={{fontSize:52,marginBottom:14}}>🎉</div><h2 style={{fontWeight:900,fontSize:22,color:DK,marginBottom:8}}>{tab==="login"?"Welcome back!":"Account created!"}</h2><p style={{color:GR,fontSize:14}}>Taking you to your dashboard...</p></div>):(<>
        <div style={{display:"flex",background:BG,borderRadius:12,padding:4,marginBottom:22}}>
          {[["login","Log In"],["signup","Sign Up"]].map(([t,lb])=><button key={t} onClick={()=>{setTab(t);setError("");}} style={{flex:1,padding:"10px",borderRadius:10,border:"none",background:tab===t?"#fff":"transparent",color:tab===t?P:GR,fontWeight:tab===t?700:500,fontSize:14,cursor:"pointer",boxShadow:tab===t?"0 2px 8px rgba(0,0,0,0.08)":"none"}}>{lb}</button>)}
        </div>
        {tab==="signup"&&<div style={{marginBottom:16}}>
          <div style={{fontSize:12,fontWeight:600,color:GR,marginBottom:10}}>I am a...</div>
          {portals.map(p=><div key={p.value} onClick={()=>setPortal(p.value)} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 14px",borderRadius:12,border:`2px solid ${portal===p.value?P:"#E0D9FF"}`,background:portal===p.value?PL:"#fff",cursor:"pointer",marginBottom:8}}>
            <div style={{width:22,height:22,borderRadius:"50%",border:`2px solid ${portal===p.value?P:"#D1D5DB"}`,background:portal===p.value?P:"#fff",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>{portal===p.value&&<div style={{width:8,height:8,borderRadius:"50%",background:"#fff"}}/>}</div>
            <div><div style={{fontWeight:600,fontSize:13,color:DK}}>{p.icon} {p.label}</div><div style={{fontSize:11,color:GR}}>{p.desc}</div></div>
          </div>)}
        </div>}
        {tab==="signup"&&<div><label style={{fontSize:12,fontWeight:600,color:GR,display:"block",marginBottom:6}}>Full Name</label><input value={form.name} onChange={e=>upd("name",e.target.value)} placeholder="e.g. Adaeze Okonkwo" style={inp}/></div>}
        <div><label style={{fontSize:12,fontWeight:600,color:GR,display:"block",marginBottom:6}}>Email Address</label><input value={form.email} onChange={e=>upd("email",e.target.value)} placeholder="you@example.com" type="email" style={inp}/></div>
        <div><label style={{fontSize:12,fontWeight:600,color:GR,display:"block",marginBottom:6}}>Password</label><input value={form.password} onChange={e=>upd("password",e.target.value)} placeholder={tab==="signup"?"Min. 6 characters":"Your password"} type="password" style={{...inp,marginBottom:tab==="login"?6:12}} onKeyDown={e=>e.key==="Enter"&&submit()}/></div>
        {tab==="login"&&<div style={{textAlign:"right",marginBottom:12}}><span style={{fontSize:12,color:P,cursor:"pointer",fontWeight:600}}>Forgot password?</span></div>}
        {error&&<div style={{background:"#FEF2F2",border:"1px solid #FECACA",borderRadius:10,padding:"10px 14px",marginBottom:14,fontSize:13,color:"#DC2626"}}>⚠️ {error}</div>}
        <button onClick={submit} disabled={loading} style={{width:"100%",background:`linear-gradient(135deg,${P},#5B21B6)`,color:"#fff",border:"none",borderRadius:12,padding:"13px",fontWeight:700,fontSize:15,cursor:loading?"not-allowed":"pointer",opacity:loading?0.85:1,marginBottom:12,boxShadow:`0 4px 20px ${P}40`}}>{loading?"Please wait...":tab==="login"?"Log In ":"Create Account "}</button>
        <div style={{textAlign:"center",fontSize:13,color:GR}}>{tab==="login"?<>Don't have an account? <span onClick={()=>{setTab("signup");setError("");}} style={{color:P,fontWeight:700,cursor:"pointer"}}>Sign up free</span></>:<>Already have an account? <span onClick={()=>{setTab("login");setError("");}} style={{color:P,fontWeight:700,cursor:"pointer"}}>Log in</span></>}</div>
      </>)}
    </div>
  </div>);
}

function UpgradeModal({onClose,onSuccess,user}){
  const{mob}=useBP();const[loading,setLoading]=useState(false);const[done,setDone]=useState(false);const[error,setError]=useState("");
  function loadPaystackScript(){
    return new Promise((resolve,reject)=>{
      if(window.PaystackPop){resolve();return;}
      const script=document.createElement("script");
      script.src="https://js.paystack.co/v1/inline.js";
      script.onload=resolve;
      script.onerror=()=>reject(new Error("Could not load payment script"));
      document.body.appendChild(script);
    });
  }
  async function pay(){
    setError("");
    setLoading(true);
    try{
      const{data:{user:authUser},error:userErr}=await supabase.auth.getUser();
      if(userErr||!authUser){setLoading(false);setError("Please log in again before upgrading.");return;}
      await loadPaystackScript();
      const handler=window.PaystackPop.setup({
        key:process.env.REACT_APP_PAYSTACK_PUBLIC_KEY,
        email:authUser.email,
        amount:300000,
        currency:"NGN",
        ref:`talebis_${Date.now()}`,
        callback:function(response){
          (async()=>{
            try{
              const API=process.env.REACT_APP_API_URL||"https://talebis-backend-production.up.railway.app";
              const res=await fetch(`${API}/api/paystack/verify`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({reference:response.reference,userId:authUser.id})});
              const data=await res.json();
              setLoading(false);
              if(data.success){setDone(true);setTimeout(()=>{onSuccess();onClose();},2000);}
              else{setError("Payment could not be verified. Please contact support.");}
            }catch{setLoading(false);setError("Payment verification failed. Please try again.");}
          })();
        },
        onClose:function(){setLoading(false);}
      });
      handler.openIframe();
    }catch(err){setLoading(false);setError(err.message||"Could not start payment. Please try again.");}
  }
  return(<div style={{position:"fixed",inset:0,background:"rgba(15,10,30,0.75)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:500,padding:16}}>
    <div style={{background:"#fff",borderRadius:20,padding:mob?24:36,width:"100%",maxWidth:460,position:"relative",boxShadow:`0 20px 60px ${P}30`}}>
      <button onClick={onClose} style={{position:"absolute",top:14,right:14,background:PL,border:"none",borderRadius:"50%",width:32,height:32,cursor:"pointer",fontSize:14,color:GR}}>✕</button>
      {done?(<div style={{textAlign:"center",padding:"20px 0"}}><div style={{fontSize:56,marginBottom:14}}>🎉</div><h2 style={{fontWeight:900,fontSize:22,color:DK}}>Welcome to Premium!</h2><p style={{color:GR}}>Your account has been upgraded.</p></div>):(<>
        <div style={{textAlign:"center",marginBottom:20}}><div style={{display:"flex",alignItems:"center",justifyContent:"center",gap:10,marginBottom:10}}><Logo size={34}/><span style={{fontWeight:900,fontSize:18,color:DK}}>Talebis Premium</span></div><p style={{color:GR,fontSize:13,margin:0}}>Unlock everything Talebis has to offer</p></div>
        <div style={{background:PL,borderRadius:12,padding:14,textAlign:"center",marginBottom:18}}><div style={{fontSize:11,color:P,fontWeight:600}}>Monthly Plan</div><div style={{fontSize:36,fontWeight:900,color:P}}>₦3000<span style={{fontSize:14,fontWeight:400,color:GR}}>/mo</span></div><div style={{fontSize:11,color:GR}}>Cancel anytime · No hidden fees</div></div>
        <div style={{marginBottom:16}}>{["Unlimited AI Mentor sessions","All 200+ projects","Verified portfolio badge","Exclusive job board"].map((f,i)=><div key={i} style={{display:"flex",alignItems:"center",gap:8,padding:"6px 0"}}><div style={{width:18,height:18,borderRadius:"50%",background:G,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}><span style={{color:"#fff",fontSize:10,fontWeight:700}}>✓</span></div><span style={{fontSize:13,color:DK}}>{f}</span></div>)}</div>
        {error&&<div style={{background:"#FEF2F2",border:"1px solid #FECACA",borderRadius:10,padding:"10px 14px",marginBottom:14,fontSize:13,color:"#DC2626"}}>⚠️ {error}</div>}
        <button onClick={pay} disabled={loading} style={{width:"100%",background:`linear-gradient(135deg,${P},#5B21B6)`,color:"#fff",border:"none",borderRadius:12,padding:"13px",fontWeight:700,fontSize:15,cursor:loading?"not-allowed":"pointer",opacity:loading?0.8:1,marginBottom:10,boxShadow:`0 4px 20px ${P}40`}}>{loading?"Opening Paystack...":"Pay ₦3000/month "}</button>
        <div style={{textAlign:"center",fontSize:11,color:GR}}>🔒 Secured by Paystack · SSL encrypted</div>
      </>)}
    </div>
  </div>);
}

function PortalSwitcher({current,onStudent,onEmployer,onStartup}){
  const portals=[{id:"student",icon:"🎓",label:"Student",color:P,bg:PL,action:onStudent},{id:"employer",icon:"👔",label:"Employer",color:P,bg:PL,action:onEmployer},{id:"startup",icon:"🚀",label:"Startup",color:GRN,bg:"#ECFDF5",action:onStartup}];
  return(<div style={{background:"#fff",borderBottom:"1px solid #F0EDFF",padding:"6px 20px",display:"flex",alignItems:"center",gap:8,flexShrink:0,flexWrap:"wrap"}}>
    <span style={{fontSize:11,color:GR,fontWeight:600,marginRight:4}}>PORTAL:</span>
    {portals.map(p=><button key={p.id} onClick={p.action} disabled={current===p.id} style={{display:"flex",alignItems:"center",gap:5,background:current===p.id?p.bg:"none",color:current===p.id?p.color:GR,border:`1.5px solid ${current===p.id?p.color+"30":"transparent"}`,borderRadius:20,padding:"5px 12px",fontWeight:current===p.id?700:500,fontSize:12,cursor:current===p.id?"default":"pointer"}}>
      <span>{p.icon}</span>{p.label}{current===p.id&&<span style={{fontSize:9,fontWeight:700,background:p.color,color:"#fff",borderRadius:10,padding:"1px 5px",marginLeft:2}}>ACTIVE</span>}
    </button>)}
  </div>);
}

function TopBar({onMenu,isPremium,onUpgrade}){
  const{mob}=useBP();
  return(<div style={{height:60,background:"#fff",borderBottom:"1px solid #F0EDFF",display:"flex",alignItems:"center",padding:`0 ${mob?12:24}px`,gap:12,flexShrink:0}}>
    {mob&&<button onClick={onMenu} style={{...btn("none",DK),fontSize:22}}>☰</button>}
    <input placeholder="Search..." style={{flex:1,maxWidth:320,padding:"9px 14px",borderRadius:10,border:"1.5px solid #F0EDFF",background:BG,fontSize:13,outline:"none",color:DK}}/>
    <div style={{flex:1}}/>
    {!isPremium&&!mob&&<button onClick={onUpgrade} style={{...btn(`linear-gradient(135deg,${P},#5B21B6)`,"#fff"),padding:"8px 18px",borderRadius:20,display:"flex",alignItems:"center",gap:5,flexShrink:0}}>👑 Upgrade</button>}
    <div style={{position:"relative",flexShrink:0,cursor:"pointer"}}><span style={{fontSize:20}}>🔔</span><div style={{position:"absolute",top:-4,right:-4,width:16,height:16,background:RE,borderRadius:"50%",fontSize:9,color:"#fff",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700}}>2</div></div>
  </div>);
}

const S_NAV=[["⊞","Dashboard"],["🤖","AI Mentor"],["📚","Learning Paths"],["🏗️","Projects"],["⚡","Challenges"],["⭐","XP & Rewards"],["🏆","Leaderboard"],["📁","Portfolio"],["💼","Career Hub"],["👥","Community"],["💬","Messages"]];
function StudentSidebar({active,setActive,open,setOpen,isPremium}){
  const{mob}=useBP();
  const inner=(<div style={{width:220,height:"100%",background:"#fff",borderRight:"1px solid #F0EDFF",display:"flex",flexDirection:"column",padding:"20px 0",flexShrink:0,overflowY:"auto"}}>
    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"0 16px 20px"}}>
      <div style={{display:"flex",alignItems:"center",gap:8}}><Logo size={32}/><div><div style={{fontWeight:800,fontSize:16,color:DK}}>Talebis</div>{isPremium&&<div style={{fontSize:9,fontWeight:700,color:OR}}>👑 PREMIUM</div>}</div></div>
      {mob&&<button onClick={()=>setOpen(false)} style={{...btn("none",GR),fontSize:18}}>✕</button>}
    </div>
    <div style={{flex:1}}>{S_NAV.map(([ic,lb])=><div key={lb} onClick={()=>{setActive(lb);if(mob)setOpen(false);}} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 16px",cursor:"pointer",background:active===lb?PL:"none",borderRight:active===lb?`3px solid ${P}`:"3px solid transparent",color:active===lb?P:GR,fontWeight:active===lb?700:500,fontSize:14}}><span style={{fontSize:15}}>{ic}</span>{lb}</div>)}</div>
    <div>{[["⚙️","Settings"],["↪️","Log out"]].map(([ic,lb])=><div key={lb} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 16px",cursor:"pointer",color:GR,fontSize:14}}><span>{ic}</span>{lb}</div>)}</div>
  </div>);
  if(mob){if(!open)return null;return(<><div onClick={()=>setOpen(false)} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.4)",zIndex:200}}/><div style={{position:"fixed",top:0,left:0,height:"100%",zIndex:201}}>{inner}</div></>);}
  return inner;
}

function StudentDash({isPremium,onUpgrade,user}){
  const{mob,tab}=useBP();const[sec,setSec]=useState(13*3600+45*60+32);
  useEffect(()=>{const t=setInterval(()=>setSec(s=>Math.max(0,s-1)),1000);return()=>clearInterval(t);},[]);
  const fmt=s=>`${String(Math.floor(s/3600)).padStart(2,"0")}:${String(Math.floor((s%3600)/60)).padStart(2,"0")}:${String(s%60).padStart(2,"0")}`;
  return(<div style={{flex:1,overflowY:"auto",padding:mob?14:24,background:BG,display:"flex",gap:18}}>
    <div style={{flex:1,minWidth:0,display:"flex",flexDirection:"column",gap:16}}>
      {!isPremium&&<div style={{background:`linear-gradient(135deg,${P},#5B21B6)`,borderRadius:14,padding:"14px 18px",display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:10}}><div><div style={{fontWeight:700,fontSize:14,color:"#fff"}}>👑 You're on the Free plan</div><div style={{fontSize:12,color:"#C4B5FD"}}>Upgrade for unlimited AI, all projects & more</div></div><button onClick={onUpgrade} style={{...btn("#fff",P),padding:"9px 18px"}}>Upgrade -- ₦3000/mo</button></div>}
      <div><h2 style={{fontWeight:900,fontSize:mob?18:22,color:DK,margin:"0 0 4px"}}>Welcome back, {user?.name||"there"}! 👋</h2><p style={{color:GR,fontSize:13,margin:0}}>Keep learning, keep building, keep winning!</p></div>
      <div style={{display:"flex",gap:12,flexWrap:"wrap"}}>
        {[["Level","5","⭐","Innovator"],["XP","2,450","🟢","+150 today"],["Badges","18","🏅",""]].map(([l,v,i,s])=><div key={l} style={{...card({flex:"1 1 100px",padding:"14px 16px"})}}>
          <div style={{fontSize:11,color:GR,marginBottom:6}}>{l}</div>
          <div style={{display:"flex",alignItems:"center",gap:8}}><span style={{fontSize:18}}>{i}</span><span style={{fontWeight:900,fontSize:22,color:DK}}>{v}</span></div>
          {s&&<div style={{fontSize:11,color:G,fontWeight:600,marginTop:4}}>{s}</div>}
        </div>)}
      </div>
      <div style={{...card({padding:16})}}>
        <div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}><span style={{fontWeight:700,fontSize:14,color:DK}}>Level 5 Progress</span><span style={{fontSize:12,color:GR}}>2,450/3,500 XP</span></div>
        <XPBar pct={70}/><div style={{fontSize:11,color:GR,marginTop:5}}>70% to Level 6</div>
      </div>
      {tab&&<div style={{...card({padding:18})}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}><div style={{fontWeight:700,fontSize:14,color:DK}}>Daily Challenge</div><div style={{fontSize:12,fontWeight:700,color:RE}}>⏱ {fmt(sec)}</div></div>
        <div style={{fontWeight:700,fontSize:14,color:DK,marginBottom:4}}>⛅ Build a Weather Dashboard</div>
        <div style={{fontSize:12,color:GR,marginBottom:10}}>Use an API to build a responsive weather app.</div>
        <div style={{display:"flex",gap:8,marginBottom:12}}><span style={{fontSize:12,fontWeight:700,color:P}}>+250 XP</span><span style={{fontSize:12,color:GR}}>+</span><span style={{fontSize:12,fontWeight:700,color:OR}}>50 Bonus XP</span></div>
        <button style={{...btn(P,"#fff"),width:"100%",padding:11}}>Start Challenge</button>
      </div>}
      <div style={{...card({padding:16})}}>
        <div style={{display:"flex",justifyContent:"space-between",marginBottom:4}}><span style={{fontWeight:700,fontSize:14,color:DK}}>Recommended for you</span><span style={{fontSize:12,color:P,cursor:"pointer"}}>View all</span></div>
        {[["💻","Build a Fullstack Blog App","Project","Intermediate",500],["⚛️","Master React Basics","Course","Beginner",200],["🤖","AI Career Coaching","AI Mentor","15 min",150],["🎨","UI/UX Design Challenge","Challenge","3 days left",300]].map(([ic,ti,ty,lv,xp],i)=><div key={i} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 0",borderBottom:i<3?"1px solid #F8F7FF":"none"}}>
          <div style={{width:34,height:34,borderRadius:10,background:PL,display:"flex",alignItems:"center",justifyContent:"center",fontSize:16,flexShrink:0}}>{ic}</div>
          <div style={{flex:1,minWidth:0}}><div style={{fontWeight:600,fontSize:13,color:DK,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{ti}</div><div style={{fontSize:11,color:GR}}>{ty} · {lv}</div></div>
          <div style={{fontSize:12,fontWeight:700,color:P,flexShrink:0}}>+{xp} XP</div>
        </div>)}
      </div>
      <div style={{...card({padding:16})}}>
        <div style={{fontWeight:700,fontSize:14,color:DK,marginBottom:10}}>Frontend Development Path</div>
        <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}><span style={{fontSize:13,color:DK}}>Your Learning Path</span><span style={{fontSize:12,fontWeight:700,color:G}}>75%</span></div>
        <XPBar pct={75} color={G}/>
        <button style={{...btn(P,"#fff"),marginTop:12,padding:"10px 18px"}}>Continue Learning</button>
      </div>
      <div>
        <div style={{display:"flex",justifyContent:"space-between",marginBottom:12}}><span style={{fontWeight:700,fontSize:14,color:DK}}>Recent Projects</span><span style={{fontSize:12,color:P,cursor:"pointer"}}>View all</span></div>
        <div style={{display:"grid",gridTemplateColumns:mob?"1fr":"repeat(3,1fr)",gap:12}}>
          {[["E-commerce Website","React, Tailwind",92,P],["Task Management","Next.js, MongoDB",100,G],["Chat Application","Socket.io",80,OR]].map(([t,tg,pr,c],i)=><div key={i} style={{...card({padding:14})}}>
            <div style={{width:28,height:28,borderRadius:8,background:`${c}20`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:14,marginBottom:8}}>💻</div>
            <div style={{fontWeight:700,fontSize:13,color:DK,marginBottom:4}}>{t}</div>
            <div style={{fontSize:11,color:GR,marginBottom:8}}>{tg}</div>
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:4}}><span style={{fontSize:11,color:GR}}>Progress</span><span style={{fontSize:11,fontWeight:700,color:c}}>{pr}%</span></div>
            <div style={{height:5,background:"#F0EDFF",borderRadius:5}}><div style={{height:"100%",width:`${pr}%`,background:c,borderRadius:5}}/></div>
          </div>)}
        </div>
      </div>
    </div>
    {!tab&&<div style={{width:240,flexShrink:0,display:"flex",flexDirection:"column",gap:16}}>
      <div style={{...card({padding:14,display:"flex",justifyContent:"space-between",alignItems:"center"})}}>
        <div><div style={{fontSize:11,color:GR,marginBottom:2}}>Streak</div><div style={{fontWeight:900,fontSize:18,color:DK}}>12 days 🔥</div></div>
        <div style={{background:PL,borderRadius:10,padding:"5px 10px",fontSize:12,fontWeight:700,color:P}}>Rank #142</div>
      </div>
      <div style={{...card({padding:18})}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}><div style={{fontWeight:700,fontSize:14,color:DK}}>Daily Challenge</div><div style={{fontSize:12,fontWeight:700,color:RE}}>⏱ {fmt(sec)}</div></div>
        <div style={{fontWeight:700,fontSize:14,color:DK,marginBottom:4}}>⛅ Build a Weather Dashboard</div>
        <div style={{fontSize:12,color:GR,marginBottom:10}}>Use an API to build a responsive weather app.</div>
        <div style={{display:"flex",gap:8,marginBottom:12}}><span style={{fontSize:12,fontWeight:700,color:P}}>+250 XP</span><span style={{fontSize:12,color:GR}}>+</span><span style={{fontSize:12,fontWeight:700,color:OR}}>50 Bonus XP</span></div>
        <button style={{...btn(P,"#fff"),width:"100%",padding:11,fontSize:13}}>Start Challenge</button>
      </div>
      <div style={{...card({padding:16})}}>
        <div style={{display:"flex",justifyContent:"space-between",marginBottom:12}}><span style={{fontWeight:700,fontSize:14,color:DK}}>Leaderboard</span><span style={{fontSize:12,color:P,cursor:"pointer"}}>View all</span></div>
        {[["Sarah James",18750,1],["David Okoro",15230,2],["Mercy Eze",14880,3],["John Daniel",12450,4,true],].map(([n,xp,r,me])=><div key={n} style={{display:"flex",alignItems:"center",gap:10,padding:"7px 0",background:me?PL:"none",borderRadius:8,paddingLeft:me?8:0,marginLeft:me?-8:0,borderBottom:r<5?"1px solid #F8F7FF":"none"}}>
          <div style={{width:22,height:22,borderRadius:"50%",background:{1:OR,2:GR,3:"#CD7F32"}[r]||"#F0EDFF",color:r<=3?"#fff":DK,fontSize:11,fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>{r}</div>
          <div style={{flex:1,fontSize:13,fontWeight:me?700:500,color:DK,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{n}</div>
          <div style={{fontSize:12,fontWeight:700,color:GR,flexShrink:0}}>{xp.toLocaleString()}</div>
        </div>)}
      </div>
    </div>}
  </div>);
}

function AIMentorPage({ isPremium, onUpgrade }) {
  const { mob } = useBP();

  const welcome = {
    role: "assistant",
    text: "Hi! I'm your AI Mentor 🤖 Ask me anything about your career, skills, or job search."
  };

  const [msgs, setMsgs] = useState([welcome]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [userId, setUserId] = useState(null);
  const [chatId, setChatId] = useState(null);
  const [history, setHistory] = useState([]);
  const [count, setCount] = useState(0);
  const [historyOpen, setHistoryOpen] = useState(false);

  const ref = useRef(null);
  const gated = !isPremium && count >= 3;

  useEffect(() => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  }, [msgs, loading]);

  // Load the signed-in user, saved conversations, and today's session count.
  useEffect(() => {
    let mounted = true;

    async function loadMentorData() {
      try {
        const {
          data: { user },
          error: userError
        } = await supabase.auth.getUser();

        if (userError) throw userError;

        if (!user) {
          console.warn("AI Mentor: no signed-in user found.");
          return;
        }

        if (!mounted) return;
        setUserId(user.id);

        const { data: chats, error: chatError } = await supabase
          .from("ai_chats")
          .select("id,messages,created_at")
          .eq("user_id", user.id)
          .eq("assistant_type", "mentor")
          .order("created_at", { ascending: false });

        if (chatError) throw chatError;
        if (!mounted) return;

        const savedChats = chats || [];
        setHistory(savedChats);

        if (savedChats.length > 0) {
          const latest = savedChats[0];
          setChatId(latest.id);

          if (Array.isArray(latest.messages) && latest.messages.length > 0) {
            setMsgs(latest.messages);
          }
        }

        const start = new Date();
        start.setHours(0, 0, 0, 0);

        const { count: todayCount, error: countError } = await supabase
          .from("ai_chats")
          .select("id", { count: "exact", head: true })
          .eq("user_id", user.id)
          .eq("assistant_type", "mentor")
          .gte("created_at", start.toISOString());

        if (countError) throw countError;
        if (mounted) setCount(todayCount || 0);
      } catch (error) {
        console.error("AI MENTOR LOAD ERROR:", error);
      }
    }

    loadMentorData();

    return () => {
      mounted = false;
    };
  }, []);

  function startNewChat() {
    if (gated || loading) return;

    setChatId(null);
    setMsgs([welcome]);
    setInput("");
    setHistoryOpen(false);
  }

  function openChat(chat) {
    if (!chat || loading) return;

    setChatId(chat.id);
    setMsgs(
      Array.isArray(chat.messages) && chat.messages.length
        ? chat.messages
        : [welcome]
    );
    setInput("");
    setHistoryOpen(false);
  }

  function chatTitle(chat) {
    const firstUserMessage = chat?.messages?.find(
      message => message.role === "user"
    );

    if (firstUserMessage?.text) {
      return firstUserMessage.text.length > 42
        ? firstUserMessage.text.slice(0, 42) + "..."
        : firstUserMessage.text;
    }

    return "New Mentor Chat";
  }
  async function loadTodayCount() {
  const { data: authData } = await supabase.auth.getUser();
  const userId = authData?.user?.id;
  if (!userId) return;

  const start = new Date();
  start.setHours(0, 0, 0, 0);

  const { count: todayCount, error } = await supabase
    .from("ai_chats")
    .select("id", { count: "exact", head: true })
    .eq("user_id", userId)
    .eq("assistant_type", "mentor")
    .gte("created_at", start.toISOString());

  if (!error) setCount(todayCount || 0);
}

useEffect(() => {
  loadTodayCount();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

  async function sendMsg() {
    const txt = input.trim();

    if (!txt || loading || gated) return;

    setLoading(true);
    setInput("");

    const newMsgs = [
      ...msgs,
      { role: "user", text: txt }
    ];

    setMsgs(newMsgs);

    try {
      // Resolve the current authenticated user before saving.
      let currentUserId = userId;

      if (!currentUserId) {
        const {
          data: { user },
          error: authError
        } = await supabase.auth.getUser();

        if (authError) throw authError;
        if (!user) {
          throw new Error("Please sign in before using AI Mentor.");
        }

        currentUserId = user.id;
        setUserId(currentUserId);
      }

      const API =
  process.env.REACT_APP_API_URL ||
  "https://talebis-backend-production-962b.up.railway.app";

      const response = await fetch(`${API}/api/ai/mentor`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ messages: newMsgs })
      });

      if (!response.ok) {
        throw new Error(`AI backend returned HTTP ${response.status}`);
      }

      const data = await response.json();

      const finalMsgs = [
        ...newMsgs,
        {
          role: "assistant",
          text: data.reply || "Could you rephrase that?"
        }
      ];

      setMsgs(finalMsgs);

      // Update the currently selected conversation.
      if (chatId) {
        const { data: updatedChat, error: updateError } = await supabase
          .from("ai_chats")
          .update({ messages: finalMsgs })
          .eq("id", chatId)
          .eq("user_id", currentUserId)
          .eq("assistant_type", "mentor")
          .select("id,messages,created_at")
          .maybeSingle();

        if (updateError) throw updateError;

        if (!updatedChat) {
          throw new Error("The conversation was not saved. Please check Supabase permissions.");
        }

        // Keep the History list synchronized with the latest messages.
        setHistory(previous =>
          previous.map(chat =>
            chat.id === updatedChat.id ? updatedChat : chat
          )
        );
      } else {
        // Create a conversation only when starting a new chat.
        const { data: savedChat, error: saveError } = await supabase
          .from("ai_chats")
          .insert({
            user_id: currentUserId,
            assistant_type: "mentor",
            messages: finalMsgs
          })
          .select("id,messages,created_at")
          .single();

        if (saveError) throw saveError;

        setChatId(savedChat.id);
        setHistory(previous => [
          savedChat,
          ...previous.filter(chat => chat.id !== savedChat.id)
        ]);
        setCount(previous => previous + 1);
      }
    } catch (error) {
      console.error("AI MENTOR ERROR:", error);

      setMsgs(previous => [
        ...previous,
        {
          role: "assistant",
          text: error.message === "Please sign in before using AI Mentor."
            ? "Please sign in to save and continue your conversations."
            : "AI Mentor could not complete or save this response. Please try again. Your latest exchange may not have been saved."
        }
      ]);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div
      style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        background: BG,
        overflow: "hidden"
      }}
    >
      {/* Header */}
      <div
        style={{
          padding: `14px ${mob ? 14 : 24}px`,
          background: "#fff",
          borderBottom: "1px solid #F0EDFF",
          flexShrink: 0
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 10,
            flexWrap: "wrap"
          }}
        >
          <div>
            <h2
              style={{
                fontWeight: 900,
                fontSize: 18,
                color: DK,
                margin: "0 0 3px"
              }}
            >
              AI Mentor 🤖
            </h2>

            <p style={{ color: GR, fontSize: 12, margin: 0 }}>
              {isPremium
                ? "Unlimited sessions · Premium ✨"
                : `${count}/3 free sessions used today`}
            </p>
          </div>

          <div style={{ display: "flex", gap: 8 }}>
            <button
              onClick={() => setHistoryOpen(value => !value)}
              style={{
                ...btn("#fff", P),
                border: `1px solid ${P}30`,
                padding: "8px 12px",
                borderRadius: 9,
                fontSize: 12
              }}
            >
              🕘 History
            </button>

            <button
              onClick={startNewChat}
              disabled={gated || loading}
              style={{
                ...btn(gated ? "#E5E7EB" : P, "#fff"),
                padding: "8px 12px",
                borderRadius: 9,
                fontSize: 12,
                cursor: gated || loading ? "not-allowed" : "pointer",
                opacity: gated || loading ? 0.6 : 1
              }}
            >
              ＋ New Chat
            </button>
          </div>
        </div>
      </div>

      {/* Chat history */}
      {historyOpen && (
        <div
          style={{
            background: "#fff",
            borderBottom: "1px solid #F0EDFF",
            padding: `12px ${mob ? 14 : 24}px`,
            maxHeight: 220,
            overflowY: "auto"
          }}
        >
          <div
            style={{
              fontWeight: 800,
              fontSize: 13,
              color: DK,
              marginBottom: 8
            }}
          >
            Chat History
          </div>

          {history.length === 0 ? (
            <div style={{ fontSize: 12, color: GR, padding: "10px 0" }}>
              No previous chats yet.
            </div>
          ) : (
            history.map(chat => (
              <button
                key={chat.id}
                onClick={() => openChat(chat)}
                disabled={loading}
                style={{
                  width: "100%",
                  textAlign: "left",
                  border: "none",
                  background: chat.id === chatId ? PL : "#fff",
                  padding: "10px 12px",
                  borderRadius: 9,
                  marginBottom: 5,
                  cursor: loading ? "not-allowed" : "pointer"
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    fontWeight: 700,
                    color: DK,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap"
                  }}
                >
                  {chatTitle(chat)}
                </div>

                <div style={{ fontSize: 10, color: GR, marginTop: 3 }}>
                  {chat.messages?.length || 0} messages
                </div>
              </button>
            ))
          )}
        </div>
      )}

      {/* Messages */}
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          padding: `16px ${mob ? 14 : 24}px`,
          display: "flex",
          flexDirection: "column",
          gap: 12
        }}
      >
        {msgs.map((message, index) => (
          <div
            key={`${index}-${message.role}`}
            style={{
              display: "flex",
              justifyContent:
                message.role === "user" ? "flex-end" : "flex-start"
            }}
          >
            <div
              style={{
                maxWidth: "90%",
                padding: "11px 14px",
                borderRadius: 14,
                background: message.role === "user" ? P : "#fff",
                color: message.role === "user" ? "#fff" : DK,
                fontSize: 13,
                lineHeight: 1.55,
                boxShadow:
                  message.role === "assistant"
                    ? "0 2px 8px rgba(0,0,0,.05)"
                    : "none",
                whiteSpace: "pre-wrap",
                overflowWrap: "anywhere"
              }}
            >
              {message.text}
            </div>
          </div>
        ))}

        {loading && (
          <div style={{ display: "flex", justifyContent: "flex-start" }}>
            <div
              style={{
                background: "#fff",
                padding: "10px 14px",
                borderRadius: 14,
                fontSize: 12,
                color: GR
              }}
            >
              AI Mentor is thinking...
            </div>
          </div>
        )}

        <div ref={ref} />
      </div>

      {/* Free-session limit */}
      {gated && (
        <div
          style={{
            margin: `0 ${mob ? 14 : 24}px 10px`,
            padding: 12,
            background: "#fff",
            border: "1px solid #E9D5FF",
            borderRadius: 12,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 12
          }}
        >
          <div>
            <div style={{ fontWeight: 800, fontSize: 13, color: DK }}>
              👑 Daily limit reached
            </div>
            <div style={{ fontSize: 11, color: GR, marginTop: 3 }}>
              Upgrade to Premium for unlimited AI Mentor sessions.
            </div>
          </div>

          <button
            onClick={onUpgrade}
            style={{
              ...btn(P, "#fff"),
              padding: "9px 12px",
              borderRadius: 9,
              flexShrink: 0
            }}
          >
            Upgrade
          </button>
        </div>
      )}

      {/* Message input */}
      <div
        style={{
          display: "flex",
          gap: 8,
          padding: `12px ${mob ? 14 : 24}px`,
          background: "#fff",
          borderTop: "1px solid #F0EDFF",
          alignItems: "flex-end"
        }}
      >
        <textarea
          value={input}
          onChange={event => setInput(event.target.value)}
          onKeyDown={event => {
            if (event.key === "Enter" && !event.shiftKey) {
              event.preventDefault();
              sendMsg();
            }
          }}
          placeholder={
            gated
              ? "Daily free sessions used"
              : "Ask your AI Mentor..."
          }
          disabled={loading || gated}
          rows={1}
          style={{
            flex: 1,
            minWidth: 0,
            resize: "vertical",
            maxHeight: 120,
            padding: "11px 13px",
            borderRadius: 10,
            border: "1.5px solid #E5E7EB",
            outline: "none",
            fontSize: 13,
            fontFamily: "inherit",
            lineHeight: 1.5,
            background: gated ? "#F5F5F5" : "#fff"
          }}
        />

        <button
          onClick={sendMsg}
          disabled={loading || gated || !input.trim()}
          style={{
            ...btn(P, "#fff"),
            padding: "10px 16px",
            borderRadius: 10,
            opacity: loading || gated || !input.trim() ? 0.5 : 1,
            cursor:
              loading || gated || !input.trim()
                ? "not-allowed"
                : "pointer"
          }}
        >
          {loading ? "Thinking..." : "Send"}
        </button>
      </div>
    </div>
  );
}
      
function CareerHubPage({isPremium,onUpgrade}){
  const{mob}=useBP();
  return(<div style={{flex:1,overflowY:"auto",padding:mob?14:24,background:BG}}>
    <h2 style={{fontWeight:900,fontSize:mob?18:22,color:DK,margin:"0 0 4px"}}>Career Hub 💼</h2>
    <p style={{color:GR,fontSize:13,margin:"0 0 16px"}}>Find internships, jobs and connect with top employers.</p>
    {!isPremium&&<div style={{background:"#fff",borderRadius:16,padding:28,textAlign:"center",border:`2px dashed ${PM}`,marginBottom:20}}><div style={{fontSize:36,marginBottom:10}}>👑</div><div style={{fontWeight:800,fontSize:16,color:DK,marginBottom:8}}>Premium Feature</div><p style={{color:GR,fontSize:13,marginBottom:18}}>Full job board access is on the Premium plan.</p><button onClick={onUpgrade} style={{...btn(P,"#fff"),padding:"12px 24px",fontSize:14,boxShadow:`0 4px 16px ${P}40`}}>Upgrade -- ₦3000/month</button></div>}
    <div style={{display:"flex",flexDirection:"column",gap:14}}>
      {[["Frontend Developer","Flutterwave","Lagos (Remote)","Full-time","₦300k-₦500k/mo",true],["Product Designer","Paystack","Lagos","Full-time","₦250k-₦400k/mo",false],["Backend Engineer","Cowrywise","Remote","Full-time","₦350k-₦600k/mo",false]].map(([t,c,l,ty,s,show],i)=><div key={i} style={{...card({padding:20,filter:!isPremium&&!show?"blur(4px)":"none",pointerEvents:!isPremium&&!show?"none":"auto"})}}>
        <div style={{display:"flex",justifyContent:"space-between",flexWrap:"wrap",gap:10,marginBottom:14}}><div><div style={{fontWeight:700,fontSize:15,color:DK}}>{t}</div><div style={{fontSize:13,color:GR}}>{c} · {l}</div></div><div style={{textAlign:"right"}}><div style={{fontSize:13,fontWeight:700,color:G}}>{s}</div><div style={{fontSize:11,color:GR}}>{ty}</div></div></div>
        <button style={{...btn(isPremium?P:"#F0EDFF",isPremium?"#fff":GR),padding:"9px 20px",cursor:isPremium?"pointer":"not-allowed"}}>{isPremium?"Apply Now":"🔒 Premium Only"}</button>
      </div>)}
    </div>
  </div>);
}

function XPRewardsPage(){
  const{mob}=useBP();const[tab,setTab]=useState("overview");const[claimed,setClaimed]=useState([]);
  const BADGES=[{ic:"🔥",l:"7-Day Streak",r:"Common",e:true},{ic:"⚡",l:"First Project",r:"Common",e:true},{ic:"💎",l:"React Master",r:"Rare",e:true},{ic:"🏆",l:"Top 1%",r:"Epic",e:true},{ic:"📁",l:"Portfolio Pro",r:"Uncommon",e:false},{ic:"🎯",l:"Challenge King",r:"Epic",e:false}];
  const REWARDS=[{ic:"🎧",l:"Spotify Premium",c:500},{ic:"📘",l:"Udemy Voucher",c:300},{ic:"☕",l:"Coffee Money ₦2k",c:200},{ic:"💳",l:"Airtime ₦1k",c:150}];
  const RC={Common:{bg:"#F3F4F6",tx:GR},Uncommon:{bg:"#ECFDF5",tx:"#059669"},Rare:{bg:"#EFF6FF",tx:"#2563EB"},Epic:{bg:PL,tx:P}};
  const pts=120;
  return(<div style={{flex:1,overflowY:"auto",background:BG}}>
    <div style={{background:`linear-gradient(135deg,${DK},#2D1B6B)`,padding:`22px ${mob?14:28}px 0`}}>
      <h2 style={{fontWeight:900,fontSize:mob?20:24,color:"#fff",margin:"0 0 14px"}}>Gamification Hub 🏆</h2>
      <div style={{display:"flex",gap:10,flexWrap:"wrap",marginBottom:18}}>
        {[["⭐","XP","2,450"],["🚀","Level","5"],["🔥","Streak","12d"],["🎁","Points","120pts"]].map(([ic,l,v])=><div key={l} style={{display:"flex",alignItems:"center",gap:8,background:"rgba(255,255,255,0.1)",borderRadius:12,padding:"8px 14px"}}><span style={{fontSize:16}}>{ic}</span><div><div style={{fontSize:10,color:"#C4B5FD"}}>{l}</div><div style={{fontSize:13,color:"#fff",fontWeight:700}}>{v}</div></div></div>)}
      </div>
      <div style={{display:"flex",gap:2}}>
        {[["overview","Overview"],["badges","Badges"],["rewards","Rewards"]].map(([id,lb])=><button key={id} onClick={()=>setTab(id)} style={{...btn(tab===id?"#fff":"transparent",tab===id?P:"#C4B5FD"),borderRadius:"10px 10px 0 0",padding:"10px 16px"}}>{lb}</button>)}
      </div>
    </div>
    <div style={{padding:mob?14:24}}>
      {tab==="overview"&&<div style={{...card({padding:24})}}>
        <div style={{fontWeight:700,fontSize:15,color:DK,marginBottom:14}}>Level 5 -- Innovator</div>
        <div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}><span style={{fontSize:13,color:GR}}>2,450 / 3,500 XP</span><span style={{fontSize:13,fontWeight:700,color:P}}>70%</span></div>
        <XPBar pct={70}/>
        <div style={{marginTop:20,padding:18,background:`linear-gradient(135deg,${P},#5B21B6)`,borderRadius:14,textAlign:"center"}}>
          <div style={{fontSize:12,color:"#C4B5FD"}}>Reward Points</div>
          <div style={{fontSize:36,fontWeight:900,color:"#fff"}}>{pts} <span style={{fontSize:14,fontWeight:400}}>pts</span></div>
          <button onClick={()=>setTab("rewards")} style={{...btn("#fff",P),marginTop:10,width:"100%",padding:10}}>Redeem Rewards 🎁</button>
        </div>
      </div>}
      {tab==="badges"&&<div>
        <div style={{fontWeight:700,fontSize:14,color:DK,marginBottom:12}}>Earned</div>
        <div style={{display:"grid",gridTemplateColumns:mob?"1fr 1fr":"repeat(4,1fr)",gap:12,marginBottom:20}}>
          {BADGES.filter(b=>b.e).map((b,i)=><div key={i} style={{...card({padding:16,textAlign:"center"})}}><div style={{fontSize:30,marginBottom:8}}>{b.ic}</div><div style={{fontWeight:700,fontSize:13,color:DK,marginBottom:4}}>{b.l}</div><div style={{display:"inline-block",padding:"2px 8px",borderRadius:20,background:RC[b.r]?.bg,color:RC[b.r]?.tx,fontSize:10,fontWeight:700}}>{b.r}</div></div>)}
        </div>
        <div style={{fontWeight:700,fontSize:14,color:DK,marginBottom:12}}>Locked</div>
        <div style={{display:"grid",gridTemplateColumns:mob?"1fr 1fr":"repeat(4,1fr)",gap:12}}>
          {BADGES.filter(b=>!b.e).map((b,i)=><div key={i} style={{...card({padding:16,textAlign:"center",opacity:0.6})}}><div style={{fontSize:30,marginBottom:8,filter:"grayscale(1)"}}>{b.ic}</div><div style={{fontWeight:700,fontSize:13,color:GR}}>{b.l}</div><div style={{fontSize:10,color:GR,marginTop:4}}>🔒 {b.r}</div></div>)}
        </div>
      </div>}
      {tab==="rewards"&&<div>
        <div style={{background:`linear-gradient(135deg,${P},#5B21B6)`,borderRadius:14,padding:18,marginBottom:16,display:"flex",justifyContent:"space-between",alignItems:"center"}}><div style={{fontSize:12,color:"#C4B5FD"}}>Balance</div><div style={{fontSize:32,fontWeight:900,color:"#fff"}}>{pts} pts</div></div>
        <div style={{display:"grid",gridTemplateColumns:mob?"1fr":"1fr 1fr",gap:14}}>
          {REWARDS.map((r,i)=>{const ok=pts>=r.c;const cl=claimed.includes(i);return(<div key={i} style={{...card({padding:18,opacity:cl?0.7:1})}}><div style={{fontSize:28,marginBottom:8}}>{r.ic}</div><div style={{fontWeight:700,fontSize:14,color:DK,marginBottom:10}}>{r.l}</div><div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}><span style={{fontWeight:900,color:OR}}>{r.c} pts</span><button disabled={!ok||cl} onClick={()=>setClaimed(x=>[...x,i])} style={{...btn(cl?G:ok?P:"#F0EDFF",cl||ok?"#fff":GR),padding:"7px 12px",cursor:!ok||cl?"not-allowed":"pointer"}}>{cl?"✓ Claimed":ok?"Redeem":"Need more"}</button></div></div>);})}
        </div>
      </div>}
    </div>
  </div>);
}
const CANDS=[{name:"Adaeze Okonkwo",role:"Frontend Dev",level:8,xp:7800,badges:24,score:94,skills:["React","Tailwind","Node.js"],status:"New",av:"AO"},{name:"Emeka Nwosu",role:"UI/UX Designer",level:6,xp:5200,badges:18,score:88,skills:["Figma","Prototyping","CSS"],status:"Reviewed",av:"EN"},{name:"Fatima Bello",role:"Backend Dev",level:7,xp:6400,badges:21,score:91,skills:["Node.js","MongoDB","Express"],status:"Shortlisted",av:"FB"},{name:"Ngozi Adeleke",role:"Frontend Dev",level:9,xp:9200,badges:30,score:97,skills:["React","TypeScript","GraphQL"],status:"Shortlisted",av:"NA"}];
const EJOBS=[{title:"Frontend Developer",type:"Full-time",loc:"Lagos (Remote)",salary:"₦300k-₦500k",applicants:24,views:312,status:"Active",posted:"3 days ago"},{title:"Product Designer",type:"Contract",loc:"Lagos",salary:"₦250k-₦400k",applicants:18,views:208,status:"Active",posted:"1 week ago"}];
const SC={New:{bg:"#EFF6FF",tx:"#2563EB"},Reviewed:{bg:"#FFFBEB",tx:"#D97706"},Shortlisted:{bg:"#ECFDF5",tx:"#059669"},Active:{bg:"#ECFDF5",tx:"#059669"},Draft:{bg:"#F3F4F6",tx:GR}};
function EmployerSidebar({active,setActive,open,setOpen}){
  const{mob}=useBP();
  const inner=(<div style={{width:220,height:"100%",background:DK,display:"flex",flexDirection:"column",padding:"20px 0",flexShrink:0,overflowY:"auto"}}>
    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"0 16px 22px"}}>
      <div style={{display:"flex",alignItems:"center",gap:8}}><Logo size={30}/><div><div style={{fontWeight:800,fontSize:16,color:"#fff"}}>Talebis</div><div style={{fontSize:9,color:PM,fontWeight:600}}>EMPLOYER</div></div></div>
      {mob&&<button onClick={()=>setOpen(false)} style={{...btn("none",GR),fontSize:18}}>✕</button>}
    </div>
    <div style={{flex:1}}>{[["⊞","Overview"],["💼","Job Postings"],["👥","Candidates"],["📊","Analytics"],["💬","Messages"],["⚙️","Settings"]].map(([ic,lb])=><div key={lb} onClick={()=>{setActive(lb);if(mob)setOpen(false);}} style={{display:"flex",alignItems:"center",gap:12,padding:"11px 16px",cursor:"pointer",background:active===lb?"rgba(124,58,237,0.2)":"none",borderLeft:active===lb?`3px solid ${PM}`:"3px solid transparent",color:active===lb?"#fff":"#9CA3AF",fontWeight:active===lb?700:400,fontSize:14}}><span style={{fontSize:15}}>{ic}</span>{lb}</div>)}</div>
    <div style={{margin:"0 12px 8px",background:"rgba(255,255,255,0.06)",borderRadius:12,padding:12,display:"flex",alignItems:"center",gap:10}}><div style={{width:34,height:34,borderRadius:10,background:P,display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontWeight:700,fontSize:13}}>TC</div><div><div style={{fontWeight:700,fontSize:13,color:"#fff"}}>TechCorp Nigeria</div><div style={{fontSize:11,color:"#9CA3AF"}}>Pro Plan · Active</div></div></div>
  </div>);
  if(mob){if(!open)return null;return(<><div onClick={()=>setOpen(false)} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:200}}/><div style={{position:"fixed",top:0,left:0,height:"100%",zIndex:201}}>{inner}</div></>);}
  return inner;
}
function EmployerOverview({setActive}){
  const{mob}=useBP();
  return(<div style={{flex:1,overflowY:"auto",padding:mob?14:24,background:BG,display:"flex",flexDirection:"column",gap:18}}>
    <div style={{background:`linear-gradient(135deg,${DK},#2D1B6B)`,borderRadius:16,padding:mob?20:28}}>
      <h2 style={{fontWeight:900,fontSize:mob?20:26,color:"#fff",margin:"0 0 8px"}}>TechCorp Nigeria 👋</h2>
      <p style={{color:"#C4B5FD",fontSize:13,margin:"0 0 18px"}}>You have 12 new applicants this week.</p>
      <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
        <button onClick={()=>setActive("Candidates")} style={{...btn(P,"#fff"),padding:"10px 20px"}}>View Candidates</button>
        <button onClick={()=>setActive("Job Postings")} style={{...btn("rgba(255,255,255,0.1)","#fff"),padding:"10px 20px",border:"1px solid rgba(255,255,255,0.2)"}}>Manage Jobs</button>
      </div>
    </div>
    <div style={{display:"grid",gridTemplateColumns:mob?"1fr 1fr":"repeat(4,1fr)",gap:14}}>
      {[["💼","Active Jobs","2","1 draft"],["👥","Applicants","51","+12 this week"],["⭐","Shortlisted","8","Pending"],["👁️","Profile Views","1.2k","+18% month"]].map(([ic,l,v,s])=><div key={l} style={{...card({padding:16})}}><div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}><span style={{fontSize:11,color:GR}}>{l}</span><span style={{fontSize:18}}>{ic}</span></div><div style={{fontWeight:900,fontSize:26,color:DK,marginBottom:4}}>{v}</div><div style={{fontSize:11,color:G,fontWeight:600}}>{s}</div></div>)}
    </div>
    <div style={{...card({padding:20})}}>
      <div style={{display:"flex",justifyContent:"space-between",marginBottom:14}}><span style={{fontWeight:700,fontSize:14,color:DK}}>Recent Applicants</span><span onClick={()=>setActive("Candidates")} style={{fontSize:12,color:P,cursor:"pointer"}}>View all</span></div>
      {CANDS.slice(0,3).map((c,i)=><div key={i} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 0",borderBottom:i<2?"1px solid #F8F7FF":"none"}}>
        <div style={{width:36,height:36,borderRadius:"50%",background:`linear-gradient(135deg,${P},${PM})`,display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontWeight:700,fontSize:12,flexShrink:0}}>{c.av}</div>
        <div style={{flex:1}}><div style={{fontWeight:600,fontSize:13,color:DK}}>{c.name}</div><div style={{fontSize:11,color:GR}}>{c.role}</div></div>
        <div style={{fontSize:13,fontWeight:800,color:P}}>{c.score}%</div>
        <div style={{fontSize:10,fontWeight:700,padding:"3px 8px",borderRadius:20,background:SC[c.status]?.bg,color:SC[c.status]?.tx}}>{c.status}</div>
      </div>)}
    </div>
  </div>);
}
function CandidatesPage(){
  const{mob}=useBP();const[filter,setFilter]=useState("All");const[sel,setSel]=useState(null);
  const list=filter==="All"?CANDS:CANDS.filter(c=>c.status===filter);
  if(sel)return(<div style={{flex:1,overflowY:"auto",padding:mob?14:24,background:BG}}>
    <button onClick={()=>setSel(null)} style={{...btn("none",P),marginBottom:16,fontSize:14}}>Backk</button>
    <div style={{display:"flex",gap:20,flexWrap:"wrap"}}>
      <div style={{flex:"1 1 260px",...card({padding:24,textAlign:"center"})}}>
        <div style={{width:68,height:68,borderRadius:"50%",background:`linear-gradient(135deg,${P},${PM})`,display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontWeight:900,fontSize:22,margin:"0 auto 12px"}}>{sel.av}</div>
        <div style={{fontWeight:800,fontSize:18,color:DK,marginBottom:4}}>{sel.name}</div><div style={{fontSize:13,color:GR,marginBottom:14}}>{sel.role}</div>
        <div style={{display:"flex",justifyContent:"center",gap:6,flexWrap:"wrap",marginBottom:16}}>{sel.skills.map(s=><span key={s} style={{fontSize:11,fontWeight:600,color:P,background:PL,borderRadius:20,padding:"3px 10px"}}>{s}</span>)}</div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10,marginBottom:20}}>{[["Level",sel.level],["XP",sel.xp.toLocaleString()],["Badges",sel.badges]].map(([l,v])=><div key={l} style={{background:BG,borderRadius:10,padding:10}}><div style={{fontWeight:800,fontSize:16,color:DK}}>{v}</div><div style={{fontSize:10,color:GR}}>{l}</div></div>)}</div>
        <div style={{display:"flex",flexDirection:"column",gap:10}}>
          <button style={{...btn(P,"#fff"),padding:12,fontSize:14}}>Send Interview Invite</button>
          <button style={{...btn("#ECFDF5",G),padding:12,fontSize:14}}>✓ Shortlist</button>
        </div>
      </div>
    </div>
  </div>);
  return(<div style={{flex:1,overflowY:"auto",padding:mob?14:24,background:BG}}>
    <h2 style={{fontWeight:900,fontSize:mob?18:22,color:DK,margin:"0 0 4px"}}>Candidates</h2>
    <p style={{color:GR,fontSize:13,margin:"0 0 16px"}}>Browse verified student talent from Nigeria</p>
    <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:20}}>{["All","New","Reviewed","Shortlisted"].map(f=><button key={f} onClick={()=>setFilter(f)} style={{...btn(filter===f?P:"#fff",filter===f?"#fff":GR),border:`1.5px solid ${filter===f?P:"#E5E7EB"}`,borderRadius:20,padding:"7px 16px"}}>{f} ({f==="All"?CANDS.length:CANDS.filter(c=>c.status===f).length})</button>)}</div>
    <div style={{display:"grid",gridTemplateColumns:mob?"1fr":"1fr 1fr",gap:14}}>
      {list.map((c,i)=><div key={i} style={{...card({padding:20,cursor:"pointer"})}} onClick={()=>setSel(c)}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:12}}>
          <div style={{display:"flex",gap:12,alignItems:"center"}}>
            <div style={{width:44,height:44,borderRadius:"50%",background:`linear-gradient(135deg,${P},${PM})`,display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontWeight:700,fontSize:15,flexShrink:0}}>{c.av}</div>
            <div><div style={{fontWeight:700,fontSize:14,color:DK}}>{c.name}</div><div style={{fontSize:12,color:GR}}>{c.role}</div></div>
          </div>
          <div style={{fontSize:10,fontWeight:700,padding:"4px 10px",borderRadius:20,background:SC[c.status]?.bg,color:SC[c.status]?.tx}}>{c.status}</div>
        </div>
        <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:10}}>{c.skills.map(s=><span key={s} style={{fontSize:10,fontWeight:600,color:P,background:PL,borderRadius:20,padding:"2px 8px"}}>{s}</span>)}</div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div style={{display:"flex",alignItems:"center",gap:8}}><div style={{height:8,width:80,background:"#F0EDFF",borderRadius:8,overflow:"hidden"}}><div style={{height:"100%",width:`${c.score}%`,background:c.score>=90?G:OR,borderRadius:8}}/></div><span style={{fontSize:12,fontWeight:700,color:c.score>=90?G:OR}}>{c.score}%</span></div>
          <span style={{fontSize:12,color:P,fontWeight:600}}>View →</span>
        </div>
      </div>)}
    </div>
  </div>);
}
function JobPostingsPage(){
  const{mob}=useBP();const[showForm,setShowForm]=useState(false);const[jobs,setJobs]=useState(EJOBS);const[form,setForm]=useState({title:"",type:"Full-time",loc:"",salary:""});
  function postJob(){if(!form.title)return;setJobs(j=>[{title:form.title,type:form.type,loc:form.loc,salary:form.salary,applicants:0,views:0,status:"Active",posted:"Just now"},...j]);setForm({title:"",type:"Full-time",loc:"",salary:""});setShowForm(false);}
  return(<div style={{flex:1,overflowY:"auto",padding:mob?14:24,background:BG}}>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20,flexWrap:"wrap",gap:12}}>
      <div><h2 style={{fontWeight:900,fontSize:mob?18:22,color:DK,margin:"0 0 4px"}}>Job Postings</h2><p style={{color:GR,fontSize:13,margin:0}}>Manage all your job listings</p></div>
      <button onClick={()=>setShowForm(true)} style={{...btn(P,"#fff"),padding:"10px 20px"}}>+ Post New Job</button>
    </div>
    {showForm&&<div style={{...card({padding:24,border:`2px solid ${P}`,marginBottom:20})}}>
      <div style={{fontWeight:700,fontSize:15,color:DK,marginBottom:16}}>New Job Posting</div>
      <div style={{display:"grid",gridTemplateColumns:mob?"1fr":"1fr 1fr",gap:14,marginBottom:14}}>
        {[["Job Title","title","e.g. Frontend Developer"],["Location","loc","e.g. Lagos (Remote)"],["Salary Range","salary","e.g. ₦300k-₦500k"]].map(([l,k,ph])=><div key={k}><label style={{fontSize:12,fontWeight:600,color:GR,display:"block",marginBottom:6}}>{l}</label><input value={form[k]} onChange={e=>setForm(p=>({...p,[k]:e.target.value}))} placeholder={ph} style={{width:"100%",padding:"10px 14px",borderRadius:10,border:"1.5px solid #E0D9FF",fontSize:14,outline:"none",color:DK,boxSizing:"border-box"}}/></div>)}
        <div><label style={{fontSize:12,fontWeight:600,color:GR,display:"block",marginBottom:6}}>Job Type</label><select value={form.type} onChange={e=>setForm(p=>({...p,type:e.target.value}))} style={{width:"100%",padding:"10px 14px",borderRadius:10,border:"1.5px solid #E0D9FF",fontSize:14,outline:"none",color:DK,boxSizing:"border-box",background:"#fff"}}>{["Full-time","Part-time","Contract","Internship"].map(t=><option key={t}>{t}</option>)}</select></div>
      </div>
      <div style={{display:"flex",gap:12}}><button onClick={postJob} style={{...btn(P,"#fff"),padding:"11px 24px"}}>Post Job</button><button onClick={()=>setShowForm(false)} style={{...btn("#F3F4F6",GR),padding:"11px 24px"}}>Cancel</button></div>
    </div>}
    <div style={{display:"flex",flexDirection:"column",gap:14}}>
      {jobs.map((j,i)=><div key={i} style={{...card({padding:20})}}>
        <div style={{display:"flex",justifyContent:"space-between",flexWrap:"wrap",gap:12}}>
          <div><div style={{fontWeight:700,fontSize:15,color:DK,marginBottom:4}}>{j.title}</div><div style={{fontSize:13,color:GR,marginBottom:8}}>{j.loc} · {j.type} · {j.salary}</div><div style={{display:"flex",gap:14}}><span style={{fontSize:12,color:GR}}>👥 {j.applicants}</span><span style={{fontSize:12,color:GR}}>👁️ {j.views}</span><span style={{fontSize:12,color:GR}}>📅 {j.posted}</span></div></div>
          <div style={{display:"flex",alignItems:"center",gap:10,flexWrap:"wrap"}}>
            <div style={{fontSize:11,fontWeight:700,padding:"4px 12px",borderRadius:20,background:SC[j.status]?.bg,color:SC[j.status]?.tx}}>{j.status}</div>
            <button style={{...btn(PL,P),padding:"8px 14px"}}>Edit</button>
          </div>
        </div>
      </div>)}
    </div>
  </div>);
}
function EmployerDash({onSwitch,onStudent,onStartup}){
  const{mob}=useBP();const[active,setActive]=useState("Overview");const[sidebarOpen,setSidebarOpen]=useState(false);
  const page=()=>{switch(active){case"Overview":return<EmployerOverview setActive={setActive}/>;case"Job Postings":return<JobPostingsPage/>;case"Candidates":return<CandidatesPage/>;default:return<div style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",background:BG,flexDirection:"column",gap:12}}><div style={{fontSize:48}}>🚧</div><div style={{fontWeight:700,fontSize:16,color:DK}}>{active} coming soon</div></div>;}};
  return(<div style={{display:"flex",height:"100dvh",fontFamily:"'Inter',system-ui,sans-serif",overflow:"hidden",flexDirection:"column"}}>
    <div style={{display:"flex",flex:1,overflow:"hidden"}}>
      <EmployerSidebar active={active} setActive={setActive} open={sidebarOpen} setOpen={setSidebarOpen}/>
      <div style={{flex:1,display:"flex",flexDirection:"column",overflow:"hidden"}}>
        <div style={{height:60,background:"#fff",borderBottom:"1px solid #F0EDFF",display:"flex",alignItems:"center",padding:`0 ${mob?12:24}px`,gap:12,flexShrink:0}}>
          {mob&&<button onClick={()=>setSidebarOpen(true)} style={{...btn("none",DK),fontSize:22}}>☰</button>}
          <div style={{fontWeight:700,fontSize:mob?15:18,color:DK,flex:1}}>{active}</div>
          <button style={{...btn(P,"#fff"),padding:"8px 16px"}}>+ Post a Job</button>
        </div>
        <PortalSwitcher current="employer" onStudent={onStudent} onEmployer={()=>{}} onStartup={onStartup}/>
        {page()}
      </div>
    </div>
    {mob&&<div style={{display:"flex",background:DK,borderTop:"1px solid rgba(255,255,255,0.1)",padding:"8px 0 4px",flexShrink:0}}>
      
    </div>}
  </div>);
}

const MILESTONES_DEF=[{id:1,label:"Validate idea with 10 users",done:true},{id:2,label:"Build MVP prototype",done:true},{id:3,label:"Launch beta to 50 users",done:true},{id:4,label:"Get first paying customer",done:false},{id:5,label:"Reach ₦1M monthly revenue",done:false}];
const FUNDING_DEF=[{name:"Tony Elumelu Foundation",type:"Grant",amount:"Up to $5,000",deadline:"Mar 2025",fit:92,icon:"🏦"},{name:"Lagos State MSME Fund",type:"Loan",amount:"Up to ₦5M",deadline:"Rolling",fit:88,icon:"🏛️"},{name:"Google for Startups Africa",type:"Accelerator",amount:"$100k + support",deadline:"Apr 2025",fit:78,icon:"🌐"},{name:"CcHUB Growth Capital",type:"Investment",amount:"$25k-$250k",deadline:"Open",fit:85,icon:"🚀"}];
function StartupSidebar({active,setActive,open,setOpen}){
  const{mob}=useBP();
  const inner=(<div style={{width:220,height:"100%",background:"#064E3B",display:"flex",flexDirection:"column",padding:"20px 0",flexShrink:0,overflowY:"auto"}}>
    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"0 16px 22px"}}>
      <div style={{display:"flex",alignItems:"center",gap:8}}><Logo size={30}/><div><div style={{fontWeight:800,fontSize:16,color:"#fff"}}>Talebis</div><div style={{fontSize:9,color:"#6EE7B7",fontWeight:600}}>STARTUP</div></div></div>
      {mob&&<button onClick={()=>setOpen(false)} style={{...btn("none","#6EE7B7"),fontSize:18}}>✕</button>}
    </div>
    <div style={{flex:1}}>{[["⊞","Overview"],["🤖","AI Advisor"],["👥","Team Builder"],["💡","Idea Validator"],["💰","Funding Hub"],["🗓️","Milestones"],["⚙️","Settings"]].map(([ic,lb])=><div key={lb} onClick={()=>{setActive(lb);if(mob)setOpen(false);}} style={{display:"flex",alignItems:"center",gap:12,padding:"11px 16px",cursor:"pointer",background:active===lb?"rgba(16,185,129,0.2)":"none",borderLeft:active===lb?"3px solid #6EE7B7":"3px solid transparent",color:active===lb?"#fff":"#6EE7B7",fontWeight:active===lb?700:400,fontSize:14}}><span style={{fontSize:15}}>{ic}</span>{lb}</div>)}</div>
    <div style={{margin:"0 12px 8px",background:"rgba(255,255,255,0.08)",borderRadius:12,padding:12,display:"flex",alignItems:"center",gap:10}}><div style={{width:34,height:34,borderRadius:10,background:GRN,display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontWeight:700,fontSize:13}}>JD</div><div><div style={{fontWeight:700,fontSize:13,color:"#fff"}}>John Daniel</div><div style={{fontSize:11,color:"#6EE7B7"}}>Founder · Talebis</div></div></div>
  </div>);
  if(mob){if(!open)return null;return(<><div onClick={()=>setOpen(false)} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:200}}/><div style={{position:"fixed",top:0,left:0,height:"100%",zIndex:201}}>{inner}</div></>);}
  return inner;
}
function StartupOverview({setActive}){
  const{mob}=useBP();const[milestones,setMilestones]=useState(MILESTONES_DEF);const done=milestones.filter(m=>m.done).length;
  return(<div style={{flex:1,overflowY:"auto",padding:mob?14:24,background:BG,display:"flex",flexDirection:"column",gap:18}}>
    <div style={{background:"linear-gradient(135deg,#064E3B,#065F46)",borderRadius:16,padding:mob?20:28}}>
      <h2 style={{fontWeight:900,fontSize:mob?20:26,color:"#fff",margin:"0 0 8px"}}>Welcome, Founder 🚀</h2>
      <p style={{color:"#A7F3D0",fontSize:13,margin:"0 0 18px"}}>You've completed {done}/{milestones.length} milestones. Keep pushing!</p>
      <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
        <button onClick={()=>setActive("AI Advisor")} style={{...btn(GRN,"#fff"),padding:"10px 20px"}}>Ask AI Advisor</button>
        <button onClick={()=>setActive("Funding Hub")} style={{...btn("rgba(255,255,255,0.1)","#fff"),padding:"10px 20px",border:"1px solid rgba(255,255,255,0.2)"}}>Find Funding</button>
      </div>
    </div>
    <div style={{display:"grid",gridTemplateColumns:mob?"1fr 1fr":"repeat(4,1fr)",gap:14}}>
      {[["🏁","Milestones",`${done}/${milestones.length}`,"Keep going!"],["👥","Team Size","1","Need 2 more"],["💰","Funding","₦0","Apply now"],["📈","Score","74%","Good start"]].map(([ic,l,v,s])=><div key={l} style={{...card({padding:16})}}><div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}><span style={{fontSize:11,color:GR}}>{l}</span><span style={{fontSize:18}}>{ic}</span></div><div style={{fontWeight:900,fontSize:24,color:DK,marginBottom:4}}>{v}</div><div style={{fontSize:11,color:GRN,fontWeight:600}}>{s}</div></div>)}
    </div>
    <div style={{display:"flex",gap:18,flexWrap:"wrap"}}>
      <div style={{flex:"1 1 280px",...card({padding:20})}}>
        <div style={{fontWeight:700,fontSize:14,color:DK,marginBottom:12}}>Startup Milestones</div>
        <div style={{height:8,background:"#F0EDFF",borderRadius:8,marginBottom:14,overflow:"hidden"}}><div style={{height:"100%",width:`${(done/milestones.length)*100}%`,background:`linear-gradient(90deg,${GRN},#34D399)`,borderRadius:8}}/></div>
        {milestones.map((m,i)=><div key={m.id} onClick={()=>setMilestones(ms=>ms.map(x=>x.id===m.id?{...x,done:!x.done}:x))} style={{display:"flex",alignItems:"center",gap:10,padding:"9px 0",borderBottom:i<milestones.length-1?"1px solid #F8F7FF":"none",cursor:"pointer"}}>
          <div style={{width:22,height:22,borderRadius:"50%",background:m.done?GRN:"#F0EDFF",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}><span style={{color:m.done?"#fff":GR,fontSize:11,fontWeight:700}}>{m.done?"✓":"○"}</span></div>
          <span style={{fontSize:13,color:m.done?GR:DK,textDecoration:m.done?"line-through":"none"}}>{m.label}</span>
        </div>)}
      </div>
      <div style={{flex:"1 1 240px",...card({padding:20})}}>   
     <div style={{fontWeight:700,fontSize:14,color:DK,marginBottom:14}}>Top Funding Matches</div>
      
{FUNDING_DEF.slice(0,3).map((f,i)=>(
  <div
    key={i}
    style={{
      display:"flex",
      alignItems:"center",
      gap:12,
      padding:"9px 0",
      borderBottom:i<2?"1px solid #F8F7FF":"none"
    }}
  >
    <div style={{
      width:34,
      height:34,
      borderRadius:10,
      background:"#ECFDF5",
      display:"flex",
      alignItems:"center",
      justifyContent:"center",
      fontSize:16,
      flexShrink:0
    }}>
      {f.icon}
    </div>

    <div style={{flex:1,minWidth:0}}>
      <div style={{
        fontWeight:600,
        fontSize:13,
        color:DK,
        overflow:"hidden",
        textOverflow:"ellipsis",
        whiteSpace:"nowrap"
      }}>
        {f.name}
      </div>
      <div style={{fontSize:11,color:GR}}>
        {f.type} · {f.amount}
      </div>
    </div>

    <div style={{
      fontSize:12,
      fontWeight:800,
      color:GRN,
      flexShrink:0
    }}>
      {f.fit}%
    </div>
  </div>
  ))}
      </div>
    </div>
  </div>);
}
function formatAdvisorText(text) {
  return text
    .replace(/\*\*(.*?)\*\*/g, "$1")
    .replace(/^#{1,6}\s+/gm, "")
    .replace(/^\s*[-*]\s+/gm, "• ");
}

function StartupAIAdvisor({isPremium}){
  const{mob}=useBP();

  const WELCOME={
    role:"assistant",
    text:"Hi Founder! 🚀 I'm your AI Startup Advisor. Ask me about idea validation, funding, pitching, co-founders, or growing your startup in Nigeria."
  };

  const[msgs,setMsgs]=useState([WELCOME]);
  const[input,setInput]=useState("");
  const[loading,setLoading]=useState(false);
  const[history,setHistory]=useState([]);
  const[showHistory,setShowHistory]=useState(false);
  const[chatId,setChatId]=useState(null);
  const[count,setCount]=useState(0);
  const ref=useRef(null);

  useEffect(()=>{
    ref.current?.scrollIntoView({behavior:"smooth"});
  },[msgs,loading]);

  useEffect(()=>{
    let mounted=true;

    async function loadChats(){
      const{data:{user}}=await supabase.auth.getUser();
      if(!user)return;

      const{data:chats,error}=await supabase
        .from("ai_chats")
        .select("id,messages,created_at")
        .eq("user_id",user.id)
        .eq("assistant_type","advisor")
        .order("created_at",{ascending:false});

      if(!error&&mounted){
        setHistory(chats||[]);
      }

      const now=new Date();
      const start=new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate()
      );

      const{data:today,error:todayError}=await supabase
        .from("ai_chats")
        .select("id")
        .eq("user_id",user.id)
        .eq("assistant_type","advisor")
        .gte("created_at",start.toISOString());

      if(!todayError&&mounted){
        setCount((today||[]).length);
      }

      if(mounted&&chats?.length){
        setChatId(chats[0].id);
        setMsgs(chats[0].messages?.length?chats[0].messages:[WELCOME]);
      }
    }

    loadChats();

    return()=>{mounted=false;};
  },[]);

  const gated=!isPremium&&count>=3;

  function newChat(){
    setChatId(null);
    setMsgs([WELCOME]);
    setInput("");
    setShowHistory(false);
  }

  function openChat(chat){
    setChatId(chat.id);
    setMsgs(chat.messages?.length?chat.messages:[WELCOME]);
    setInput("");
    setShowHistory(false);
  }

  async function sendAdvisorMsg(){
    if(!input.trim()||loading||gated)return;

    const txt=input.trim();
    const userMessage={role:"user",text:txt};
    const newMsgs=[...msgs,userMessage];

    setInput("");
    setMsgs(newMsgs);
    setLoading(true);

    try{
      const API =
  process.env.REACT_APP_API_URL ||
  "https://talebis-backend-production-962b.up.railway.app";

      const res=await fetch(`${API}/api/ai/advisor`,{
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify({messages:newMsgs})
      });

      if(!res.ok)throw new Error("backend error");

      const data=await res.json();

      const finalMsgs=[
        ...newMsgs,
        {
          role:"assistant",
          text:data.reply||"Could you rephrase that?"
        }
      ];

      setMsgs(finalMsgs);

      const{data:{user}}=await supabase.auth.getUser();

      if(!user)throw new Error("User not logged in");

      if(chatId){

        const{error}=await supabase
          .from("ai_chats")
          .update({messages:finalMsgs})
          .eq("id",chatId)
          .eq("user_id",user.id);

        if(error)console.error("ADVISOR CHAT UPDATE ERROR:",error);

      }else{

        const{data:chat,error}=await supabase
          .from("ai_chats")
          .insert({
            user_id:user.id,
            assistant_type:"advisor",
            messages:finalMsgs
          })
          .select("id,messages,created_at")
          .single();

        if(error){
          console.error("ADVISOR CHAT SAVE ERROR:",error);
        }else if(chat){

          setChatId(chat.id);
          setHistory(prev=>[chat,...prev]);
          setCount(c=>c+1);
        }
      }

    }catch(err){
      console.error("AI advisor error:",err);

      setMsgs(m=>[
        ...m,
        {
          role:"assistant",
          text:"AI Advisor is temporarily unavailable. Please try again shortly."
        }
      ]);
    }

    setLoading(false);
  }

  return(
    <div style={{
      flex:1,
      display:"flex",
      flexDirection:"column",
      background:BG,
      overflow:"hidden"
    }}>

      <div style={{
        padding:`18px ${mob?14:24}px 12px`,
        background:"#fff",
        borderBottom:"1px solid #F0EDFF",
        flexShrink:0
      }}>

        <div style={{
          display:"flex",
          alignItems:"center",
          justifyContent:"space-between",
          gap:10
        }}>

          <div>
            <h2 style={{
              fontWeight:900,
              fontSize:18,
              color:DK,
              margin:"0 0 3px"
            }}>
              AI Startup Advisor 🚀
            </h2>

            <p style={{
              color:GR,
              fontSize:12,
              margin:0
            }}>
              {isPremium
                ?"Unlimited sessions · Premium ✨"
                :`${count}/3 free sessions used today`}
            </p>
          </div>

          <div style={{
            display:"flex",
            gap:8,
            flexShrink:0
          }}>

            <button
              onClick={()=>setShowHistory(v=>!v)}
              style={{
                ...btn("#fff",DK),
                border:"1px solid #E5E7EB",
                padding:"9px 13px"
              }}
            >
              🕘 History
            </button>

            <button
              onClick={newChat}
              style={{
                ...btn(P,"#fff"),
                padding:"9px 13px"
              }}
            >
              + New Chat
            </button>

          </div>
        </div>
      </div>

      {showHistory&&(
        <div style={{
          background:"#fff",
          borderBottom:"1px solid #F0EDFF",
          padding:`12px ${mob?14:24}px`,
          maxHeight:220,
          overflowY:"auto"
        }}>

          <div style={{
            fontWeight:800,
            fontSize:13,
            color:DK,
            marginBottom:8
          }}>
            Chat History
          </div>

          {history.length===0?(
            <div style={{
              fontSize:12,
              color:GR,
              padding:"10px 0"
            }}>
              No previous conversations yet.
            </div>
          ):(
            history.map(chat=>{

              const firstUser=chat.messages?.find(
                m=>m.role==="user"
              );

              const title=firstUser?.text
                ?firstUser.text.slice(0,55)+(firstUser.text.length>55?"...":"")
                :"New startup conversation";

              return(
                <button
                  key={chat.id}
                  onClick={()=>openChat(chat)}
                  style={{
                    display:"block",
                    width:"100%",
                    textAlign:"left",
                    background:chat.id===chatId?"#F5F3FF":"#fff",
                    border:"none",
                    borderRadius:10,
                    padding:"9px 10px",
                    marginBottom:5,
                    cursor:"pointer",
                    color:DK
                  }}
                >
                  <div style={{
                    fontSize:13,
                    fontWeight:600,
                    overflow:"hidden",
                    textOverflow:"ellipsis",
                    whiteSpace:"nowrap"
                  }}>
                    {title}
                  </div>

                  <div style={{
                    fontSize:10,
                    color:GR,
                    marginTop:3
                  }}>
                    {chat.messages?.length||0} messages
                  </div>
                </button>
              );
            })
          )}
        </div>
      )}

      <div style={{
        flex:1,
        overflowY:"auto",
        padding:`16px ${mob?14:24}px`,
        display:"flex",
        flexDirection:"column",
        gap:12
      }}>

        {msgs.map((m,i)=>(
          <div
            key={i}
            style={{
              display:"flex",
              justifyContent:m.role==="user"?"flex-end":"flex-start",
              alignItems:"flex-end",
              gap:8
            }}
          >

            {m.role==="assistant"&&(
              <div style={{
                width:28,
                height:28,
                borderRadius:"50%",
                background:"#ECFDF5",
                display:"flex",
                alignItems:"center",
                justifyContent:"center",
                fontSize:14,
                flexShrink:0
              }}>
                🚀
              </div>
            )}

            <div style={{
              maxWidth:"76%",
              padding:"11px 14px",
              borderRadius:14,
              background:m.role==="user"?GRN:"#fff",
              color:m.role==="user"?"#fff":DK,
              border:m.role==="user"?"none":"1.5px solid #F0EDFF",
              fontSize:14,
              lineHeight:1.6,
              whiteSpace:"pre-wrap"
            }}>
              {formatAdvisorText(m.text)}
            </div>

          </div>
        ))}

        {loading&&(
          <div style={{
            display:"flex",
            gap:8,
            alignItems:"flex-end"
          }}>
            <div style={{
              width:28,
              height:28,
              borderRadius:"50%",
              background:"#ECFDF5",
              display:"flex",
              alignItems:"center",
              justifyContent:"center",
              fontSize:14
            }}>
              🚀
            </div>

            <div style={{
              padding:"11px 14px",
              borderRadius:14,
              background:"#fff",
              border:"1.5px solid #F0EDFF",
              color:GR,
              fontSize:14
            }}>
              Thinking...
            </div>
          </div>
        )}

        <div ref={ref}/>
      </div>

      <div style={{
        display:"flex",
        gap:8,
        padding:`12px ${mob?14:24}px`,
        background:"#fff",
        borderTop:"1px solid #F0EDFF"
      }}>

        <input
          value={input}
          onChange={e=>setInput(e.target.value)}
          onKeyDown={e=>{
            if(e.key==="Enter"&&!e.shiftKey){
              e.preventDefault();
              sendAdvisorMsg();
            }
          }}
          disabled={gated||loading}
          placeholder={
            gated
              ?"You've used your 3 free sessions today."
              :"Ask your AI Startup Advisor..."
          }
          style={{
            flex:1,
            padding:"11px 14px",
            borderRadius:12,
            border:"1.5px solid #A7F3D0",
            fontSize:14,
            outline:"none",
            color:DK
          }}
        />

        <button
          onClick={sendAdvisorMsg}
          disabled={loading||gated||!input.trim()}
          style={{
            ...btn(GRN,"#fff"),
            padding:"11px 18px",
            opacity:loading||gated||!input.trim()?0.6:1,
            flexShrink:0
          }}
        >
          {loading?"Please wait...":"Send"}
        </button>

      </div>

    </div>
  );
  }
function StartupDash({onSwitch,onStudent,onEmployer}){
  const{mob}=useBP();const[active,setActive]=useState("Overview");const[sidebarOpen,setSidebarOpen]=useState(false);
  const page=()=>{switch(active){case"Overview":return<StartupOverview setActive={setActive}/>;case"AI Advisor":return<StartupAIAdvisor/>;default:return<div style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",background:BG,flexDirection:"column",gap:12}}><div style={{fontSize:48}}>🚧</div><div style={{fontWeight:700,fontSize:16,color:DK}}>{active} coming soon</div></div>;}};
  return(<div style={{display:"flex",height:"100dvh",fontFamily:"'Inter',system-ui,sans-serif",overflow:"hidden",flexDirection:"column"}}>
    <div style={{display:"flex",flex:1,overflow:"hidden"}}>
      <StartupSidebar active={active} setActive={setActive} open={sidebarOpen} setOpen={setSidebarOpen}/>
      <div style={{flex:1,display:"flex",flexDirection:"column",overflow:"hidden"}}>
        <div style={{height:60,background:"#fff",borderBottom:"1px solid #F0EDFF",display:"flex",alignItems:"center",padding:`0 ${mob?12:24}px`,gap:12,flexShrink:0}}>
          {mob&&<button onClick={()=>setSidebarOpen(true)} style={{...btn("none",DK),fontSize:22}}>☰</button>}
          <div style={{fontWeight:700,fontSize:mob?15:18,color:DK,flex:1}}>{active}</div>
          <Logo size={28}/>
        </div>
        <PortalSwitcher current="startup" onStudent={onStudent} onEmployer={onEmployer} onStartup={()=>{}}/>
        {page()}
      </div>
    </div>
    {mob&&<div style={{display:"flex",background:"#064E3B",borderTop:"1px solid rgba(255,255,255,0.1)",padding:"8px 0 4px",flexShrink:0}}>
         {[["⊞","Overview"],["🤖","AI Advisor"],["💰","Funding"],["🗓️","Milestones"]].map(([ic,lb])=><div key={lb} onClick={()=>setActive(lb==="Funding"?"Funding Hub":lb)} style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",gap:3,cursor:"pointer",padding:"4px 0"}}><div style={{fontSize:20,filter:(active===lb||(active==="Funding Hub"&&lb==="Funding"))?"none":"grayscale(1) opacity(0.4)"}}>{ic}</div><div style={{fontSize:9,fontWeight:600,color:"#6EE7B7",opacity:(active===lb||(active==="Funding Hub"&&lb==="Funding"))?1:0.5}}>{lb}</div></div>)}
    </div>}
  </div>);
}

function AdminLogin({onLogin}){
  const[password,setPassword]=useState("");const[error,setError]=useState("");const[loading,setLoading]=useState(false);
  async function tryLogin(){if(!password){setError("Enter your admin password.");return;}setLoading(true);await new Promise(r=>setTimeout(r,800));if(password===ADMIN_KEY){onLogin();}else{setError("Incorrect password.");}setLoading(false);}
  return(<div style={{minHeight:"100vh",background:`linear-gradient(135deg,${DK},#2D1B6B)`,display:"flex",alignItems:"center",justifyContent:"center",padding:16,fontFamily:"'Inter',system-ui,sans-serif"}}>
    <div style={{background:"#fff",borderRadius:20,padding:40,maxWidth:400,width:"100%",boxShadow:`0 24px 64px ${P}40`}}>
      <div style={{textAlign:"center",marginBottom:32}}><div style={{width:56,height:56,borderRadius:16,background:`linear-gradient(135deg,${P},#5B21B6)`,display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 12px",fontSize:28}}>🛡️</div><h1 style={{fontWeight:900,fontSize:22,color:DK,margin:"0 0 4px"}}>Talebis Admin</h1><p style={{color:GR,fontSize:13,margin:0}}>Restricted access</p></div>
      <label style={{fontSize:12,fontWeight:600,color:GR,display:"block",marginBottom:8}}>Admin Password</label>
      <input type="password" value={password} onChange={e=>{setPassword(e.target.value);setError("");}} onKeyDown={e=>e.key==="Enter"&&tryLogin()} placeholder="Enter admin password" style={{width:"100%",padding:"12px 14px",borderRadius:10,border:`1.5px solid ${error?RE:"#E0D9FF"}`,fontSize:14,outline:"none",color:DK,boxSizing:"border-box",marginBottom:12}}/>
      {error&&<div style={{background:"#FEF2F2",border:"1px solid #FECACA",borderRadius:10,padding:"10px 14px",marginBottom:12,fontSize:13,color:RE}}>⚠️ {error}</div>}
      <button onClick={tryLogin} disabled={loading} style={{width:"100%",background:`linear-gradient(135deg,${P},#5B21B6)`,color:"#fff",border:"none",borderRadius:12,padding:"13px",fontWeight:700,fontSize:15,cursor:loading?"not-allowed":"pointer",opacity:loading?0.8:1,boxShadow:`0 4px 20px ${P}40`}}>{loading?"Verifying...":"Access Admin Panel "}</button>
    </div>
  </div>);
}

const MOCK_USERS=[{id:1,name:"Adaeze Okonkwo",email:"adaeze@gmail.com",portal:"student",plan:"premium",xp:7800,status:"active",lastLogin:"Today"},{id:2,name:"Emeka Nwosu",email:"emeka@outlook.com",portal:"employer",plan:"free",xp:0,status:"active",lastLogin:"Yesterday"},{id:3,name:"Fatima Bello",email:"fatima@gmail.com",portal:"startup",plan:"premium",xp:5200,status:"active",lastLogin:"Today"},{id:4,name:"Chukwudi Eze",email:"chukwudi@yahoo.com",portal:"student",plan:"free",xp:2100,status:"active",lastLogin:"3 days ago"},{id:5,name:"Ngozi Adeleke",email:"ngozi@gmail.com",portal:"student",plan:"premium",xp:9200,status:"active",lastLogin:"Today"},{id:6,name:"Tunde Okafor",email:"tunde@gmail.com",portal:"employer",plan:"free",xp:0,status:"suspended",lastLogin:"1 week ago"}];
function AdminDash({onExit}){
  const{mob}=useBP();const[active,setActive]=useState("Overview");const[sidebarOpen,setSidebarOpen]=useState(false);
  const[users,setUsers]=useState([]);const[search,setSearch]=useState("");
  const[stats,setStats]=useState({totalUsers:0,students:0,employers:0,startups:0,premiumUsers:0,activeSubscriptions:0,monthlyRevenue:0,newUsersToday:0,aiCallsToday:0});
  const[loading,setLoading]=useState(true);const[error,setError]=useState("");
  const ADMIN_KEY="talebis_admin_2024";
  const API=process.env.REACT_APP_API_URL||"https://talebis-backend-production-962b.up.railway.app";

  useEffect(()=>{
    async function fetchData(){
      setLoading(true);
      try{
        const headers={"x-admin-key":ADMIN_KEY,"Content-Type":"application/json"};
        const[statsRes,usersRes]=await Promise.all([
          fetch(`${API}/api/admin/stats`,{headers}),
          fetch(`${API}/api/admin/users`,{headers})
        ]);
        if(statsRes.ok){const d=await statsRes.json();setStats(d);}
        if(usersRes.ok){const d=await usersRes.json();setUsers(d.users||[]);}
        else{setUsers(MOCK_USERS);}
      }catch(err){
        console.error("Admin fetch failed:",err);
        setUsers(MOCK_USERS);
        setStats({totalUsers:MOCK_USERS.length,students:MOCK_USERS.filter(u=>u.portal==="student").length,employers:MOCK_USERS.filter(u=>u.portal==="employer").length,startups:MOCK_USERS.filter(u=>u.portal==="startup").length,premiumUsers:MOCK_USERS.filter(u=>u.plan==="premium").length,activeSubscriptions:MOCK_USERS.filter(u=>u.plan==="premium").length,monthlyRevenue:MOCK_USERS.filter(u=>u.plan==="premium").length*2500,newUsersToday:0,aiCallsToday:0});
        setError("Using sample data - backend not connected");
      }
      setLoading(false);
    }
    fetchData();
  },[API]);

  async function updateUserPlan(userId,plan){
    try{
      await fetch(`${API}/api/admin/users/${userId}/plan`,{method:"PATCH",headers:{"x-admin-key":ADMIN_KEY,"Content-Type":"application/json"},body:JSON.stringify({plan})});
      setUsers(us=>us.map(u=>u.id===userId?{...u,plan}:u));
    }catch(err){setUsers(us=>us.map(u=>u.id===userId?{...u,plan}:u));}
  }

  async function updateUserStatus(userId,status){
    try{
      await fetch(`${API}/api/admin/users/${userId}/status`,{method:"PATCH",headers:{"x-admin-key":ADMIN_KEY,"Content-Type":"application/json"},body:JSON.stringify({status})});
      setUsers(us=>us.map(u=>u.id===userId?{...u,status}:u));
    }catch(err){setUsers(us=>us.map(u=>u.id===userId?{...u,status}:u));}
  }
  const inner=(<div style={{width:220,height:"100%",background:DK,display:"flex",flexDirection:"column",padding:"20px 0",flexShrink:0}}>
    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"0 16px 22px"}}>
      <div style={{display:"flex",alignItems:"center",gap:8}}><div style={{width:30,height:30,borderRadius:8,background:P,display:"flex",alignItems:"center",justifyContent:"center",fontSize:15}}>🛡️</div><div><div style={{fontWeight:800,fontSize:14,color:"#fff"}}>Talebis</div><div style={{fontSize:9,color:PM,fontWeight:700,letterSpacing:1}}>ADMIN</div></div></div>
      {mob&&<button onClick={()=>setSidebarOpen(false)} style={{...btn("none",GR),fontSize:18}}>✕</button>}
    </div>
    <div style={{flex:1}}>{[["⊞","Overview"],["👥","Users"],["💰","Subscriptions"],["🤖","AI Monitor"],["📊","Analytics"],["📢","Announcements"],["⚙️","Settings"]].map(([ic,lb])=><div key={lb} onClick={()=>{setActive(lb);if(mob)setSidebarOpen(false);}} style={{display:"flex",alignItems:"center",gap:12,padding:"11px 16px",cursor:"pointer",background:active===lb?"rgba(124,58,237,0.25)":"none",borderLeft:active===lb?`3px solid ${PM}`:"3px solid transparent",color:active===lb?"#fff":"#9CA3AF",fontWeight:active===lb?700:400,fontSize:14}}><span style={{fontSize:16}}>{ic}</span>{lb}</div>)}</div>
    <div style={{padding:"0 12px"}}><div style={{background:"rgba(239,68,68,0.1)",borderRadius:10,padding:"10px 14px",display:"flex",alignItems:"center",gap:10,cursor:"pointer",marginBottom:8}} onClick={onExit}><span style={{fontSize:16}}>🏠</span><span style={{fontSize:13,color:"#FCA5A5",fontWeight:600}}>Back to Platform</span></div></div>
  </div>);
  const sidebar=mob?(<>{sidebarOpen&&<><div onClick={()=>setSidebarOpen(false)} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:200}}/><div style={{position:"fixed",top:0,left:0,height:"100%",zIndex:201}}>{inner}</div></>}</>):inner;
  const Overview=()=>(<div style={{flex:1,overflowY:"auto",padding:mob?14:24,background:BG,display:"flex",flexDirection:"column",gap:18}}>
    <div style={{background:`linear-gradient(135deg,${DK},#2D1B6B)`,borderRadius:16,padding:mob?20:28}}>
      <h2 style={{fontWeight:900,fontSize:mob?20:26,color:"#fff",margin:"0 0 8px"}}>Admin Dashboard 🛡️</h2>
      <p style={{color:"#C4B5FD",fontSize:13,margin:0}}>Platform is healthy · {stats.newUsersToday} new users today · ₦{(stats.monthlyRevenue||0).toLocaleString()} revenue this month</p>
      {error&&<div style={{marginTop:10,background:"rgba(251,191,36,0.2)",borderRadius:8,padding:"6px 12px",fontSize:12,color:"#FDE68A"}}>⚠️ {error}</div>}
    </div>
    {loading?(<div style={{textAlign:"center",padding:40,color:GR}}>Loading real data from backend...</div>):null}
    <div style={{display:"grid",gridTemplateColumns:mob?"1fr 1fr":"repeat(4,1fr)",gap:14}}>
      {[["👥","Total Users",(stats.totalUsers||0).toLocaleString(),`+${stats.newUsersToday||0} today`,P],["👑","Premium Subs",(stats.activeSubscriptions||0).toString(),"₦"+(stats.monthlyRevenue||0).toLocaleString()+"/mo",OR],["🤖","AI Calls Today",(stats.aiCallsToday||0).toLocaleString(),"Today",G],["📊","Students",(stats.students||0).toString(),`${stats.employers||0} employers`,P]].map(([ic,l,v,s,c])=><div key={l} style={{...card({padding:16})}}><div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}><span style={{fontSize:11,color:GR}}>{l}</span><span style={{fontSize:18}}>{ic}</span></div><div style={{fontWeight:900,fontSize:26,color:DK,marginBottom:4}}>{v}</div><div style={{fontSize:11,color:c,fontWeight:600}}>{s}</div></div>)}
    </div>
    <div style={{...card({padding:20})}}>
      <div style={{fontWeight:700,fontSize:14,color:DK,marginBottom:16}}>Revenue -- Last 7 Months</div>
      <div style={{display:"flex",alignItems:"flex-end",gap:10,height:100}}>
        {[180,240,195,310,280,420,780].map((v,i)=><div key={i} style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",gap:4}}><div style={{fontSize:9,color:GR}}>{v}k</div><div style={{width:"100%",height:`${(v/780)*80}px`,background:i===6?`linear-gradient(180deg,${OR},${OR}80)`:"#FEF3C7",borderRadius:"5px 5px 0 0"}}/><div style={{fontSize:9,color:GR}}>{["F","M","A","M","J","J","A"][i]}</div></div>)}
      </div>
    </div>
  </div>);
  const UsersPage=()=>(<div style={{flex:1,overflowY:"auto",padding:mob?14:24,background:BG}}>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20,flexWrap:"wrap",gap:12}}>
      <div><h2 style={{fontWeight:900,fontSize:mob?18:22,color:DK,margin:"0 0 4px"}}>Users</h2><p style={{color:GR,fontSize:13,margin:0}}>{users.length} total users</p></div>
      <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search name or email..." style={{padding:"9px 14px",borderRadius:10,border:"1.5px solid #E0D9FF",fontSize:13,outline:"none",color:DK,width:mob?"100%":220}}/>
    </div>
    <div style={{...card({padding:0,overflow:"hidden"})}}>
      <div style={{overflowX:"auto"}}>
        <table style={{width:"100%",borderCollapse:"collapse"}}>
          <thead><tr style={{background:BG}}>{["User","Portal","Plan","Status","Last Login","Actions"].map(h=><th key={h} style={{padding:"12px 16px",textAlign:"left",fontSize:11,fontWeight:700,color:GR,letterSpacing:0.5,textTransform:"uppercase",whiteSpace:"nowrap"}}>{h}</th>)}</tr></thead>
          <tbody>{users.filter(u=>u.name.toLowerCase().includes(search.toLowerCase())||u.email.toLowerCase().includes(search.toLowerCase())).map((u,i)=><tr key={u.id} style={{borderTop:"1px solid #F8F7FF"}}>
            <td style={{padding:"12px 16px"}}><div style={{display:"flex",alignItems:"center",gap:10}}><div style={{width:32,height:32,borderRadius:"50%",background:`linear-gradient(135deg,${P},${PM})`,display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontWeight:700,fontSize:12,flexShrink:0}}>{u.name[0]}</div><div><div style={{fontWeight:600,fontSize:13,color:DK}}>{u.name}</div><div style={{fontSize:11,color:GR}}>{u.email}</div></div></div></td>
            <td style={{padding:"12px 16px"}}><span style={{fontSize:10,fontWeight:700,color:DK,background:"#F3F4F6",borderRadius:20,padding:"3px 10px"}}>{u.portal}</span></td>
            <td style={{padding:"12px 16px"}}><span style={{fontSize:10,fontWeight:700,color:u.plan==="premium"?OR:GR,background:u.plan==="premium"?"#FFFBEB":"#F3F4F6",borderRadius:20,padding:"3px 10px"}}>{u.plan==="premium"?"👑 Premium":"Free"}</span></td>
            <td style={{padding:"12px 16px"}}><span style={{fontSize:10,fontWeight:700,color:u.status==="active"?G:RE,background:u.status==="active"?"#ECFDF5":"#FEF2F2",borderRadius:20,padding:"3px 10px"}}>{u.status}</span></td>
            <td style={{padding:"12px 16px",fontSize:12,color:GR}}>{u.lastLogin}</td>
            <td style={{padding:"12px 16px"}}><div style={{display:"flex",gap:6}}>
              <button onClick={()=>updateUserPlan(u.id,u.plan==="premium"?"free":"premium")} style={{fontSize:11,fontWeight:700,padding:"5px 10px",borderRadius:8,border:"none",background:PL,color:P,cursor:"pointer"}}>{u.plan==="premium"?"↓ Free":"↑ Premium"}</button>
              <button onClick={()=>updateUserStatus(u.id,u.status==="active"?"suspended":"active")} style={{fontSize:11,fontWeight:700,padding:"5px 10px",borderRadius:8,border:"none",background:u.status==="active"?"#FEF2F2":"#ECFDF5",color:u.status==="active"?RE:G,cursor:"pointer"}}>{u.status==="active"?"Suspend":"Restore"}</button>
            </div></td>
          </tr>)}</tbody>
        </table>
      </div>
    </div>
  </div>);
  const SubscriptionsPage=()=>{
    const subs=[{user:"Adaeze Okonkwo",email:"adaeze@gmail.com",amount:3000,status:"active",started:"2024-01-15",expires:"2024-09-15",ref:"talebis_001"},{user:"Fatima Bello",email:"fatima@gmail.com",amount:3000,status:"active",started:"2024-01-28",expires:"2024-09-28",ref:"talebis_003"},{user:"Ngozi Adeleke",email:"ngozi@gmail.com",amount:3000,status:"active",started:"2024-01-05",expires:"2024-09-05",ref:"talebis_005"},{user:"James Ola",email:"james@gmail.com",amount:3000,status:"cancelled",started:"2024-01-25",expires:"2024-08-25",ref:"talebis_010"}];
    return(<div style={{flex:1,overflowY:"auto",padding:mob?14:24,background:BG}}>
      <h2 style={{fontWeight:900,fontSize:mob?18:22,color:DK,margin:"0 0 4px"}}>Subscriptions 💰</h2>
      <p style={{color:GR,fontSize:13,margin:"0 0 20px"}}>All Paystack subscriptions</p>
      <div style={{display:"grid",gridTemplateColumns:mob?"1fr 1fr":"repeat(4,1fr)",gap:14,marginBottom:20}}>
        {[["✅","Active",subs.filter(s=>s.status==="active").length,G],["❌","Cancelled",subs.filter(s=>s.status==="cancelled").length,RE],["💰","Monthly Revenue" (subs.filter(s=>s.status==="active").length*2500).toLocaleString(),OR],["📈","Total Collected","₦"+(subs.length*2500).toLocaleString(),P]].map(([ic,l,v,c])=><div key={l} style={{...card({padding:16})}}><div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}><span style={{fontSize:11,color:GR}}>{l}</span><span style={{fontSize:18}}>{ic}</span></div><div style={{fontWeight:900,fontSize:24,color:c}}>{v}</div></div>)}
      </div>
      <div style={{...card({padding:0,overflow:"hidden"})}}>
        <div style={{overflowX:"auto"}}><table style={{width:"100%",borderCollapse:"collapse"}}>
          <thead><tr style={{background:BG}}>{["User","Amount","Reference","Status","Started","Expires"].map(h=><th key={h} style={{padding:"12px 16px",textAlign:"left",fontSize:11,fontWeight:700,color:GR,textTransform:"uppercase",whiteSpace:"nowrap"}}>{h}</th>)}</tr></thead>
          <tbody>{subs.map((s,i)=><tr key={i} style={{borderTop:"1px solid #F8F7FF"}}>
            <td style={{padding:"12px 16px"}}><div style={{fontWeight:600,fontSize:13,color:DK}}>{s.user}</div><div style={{fontSize:11,color:GR}}>{s.email}</div></td>
            <td style={{padding:"12px 16px",fontWeight:700,color:DK}}>₦{s.amount.toLocaleString()}</td>
            <td style={{padding:"12px 16px",fontSize:11,color:GR}}>{s.ref}</td>
            <td style={{padding:"12px 16px"}}><span style={{fontSize:10,fontWeight:700,color:s.status==="active"?G:RE,background:s.status==="active"?"#ECFDF5":"#FEF2F2",borderRadius:20,padding:"3px 10px"}}>{s.status}</span></td>
            <td style={{padding:"12px 16px",fontSize:12,color:GR}}>{s.started}</td>
            <td style={{padding:"12px 16px",fontSize:12,color:GR}}>{s.expires}</td>
          </tr>)}</tbody>
        </table></div>
      </div>
    </div>);
  };
  const AIMonitorPage=()=>(<div style={{flex:1,overflowY:"auto",padding:mob?14:24,background:BG}}>
    <h2 style={{fontWeight:900,fontSize:mob?18:22,color:DK,margin:"0 0 4px"}}>AI Monitor 🤖</h2>
    <p style={{color:GR,fontSize:13,margin:"0 0 20px"}}>Track OPENAI API usage and costs</p>
    <div style={{display:"grid",gridTemplateColumns:mob?"1fr 1fr":"repeat(4,1fr)",gap:14,marginBottom:20}}>
      {[["📡","Calls Today","2,841",P],["💸","Cost Today","$4.26",RE],["⚡","Cache Rate","68%",G],["📊","Avg Cost/Call","$0.0015",OR]].map(([ic,l,v,c])=><div key={l} style={{...card({padding:16})}}><div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}><span style={{fontSize:11,color:GR}}>{l}</span><span style={{fontSize:18}}>{ic}</span></div><div style={{fontWeight:900,fontSize:24,color:c}}>{v}</div></div>)}
    </div>
    <div style={{...card({padding:20}),marginBottom:20}}>
      <div style={{fontWeight:700,fontSize:14,color:DK,marginBottom:16}}>Monthly Cost Projection</div>
      <div style={{display:"flex",gap:16,flexWrap:"wrap"}}>
        {[["At current rate","$127.80/mo",G],["At 2x growth","$255.60/mo",OR],["At 1000 users","$510/mo",RE]].map(([l,v,c])=><div key={l} style={{flex:"1 1 140px",background:BG,borderRadius:12,padding:16,textAlign:"center"}}><div style={{fontSize:12,color:GR,marginBottom:6}}>{l}</div><div style={{fontWeight:900,fontSize:20,color:c}}>{v}</div></div>)}
      </div>
    </div>
    <div style={{...card({padding:20})}}>
      <div style={{fontWeight:700,fontSize:14,color:DK,marginBottom:16}}>Recent AI Calls</div>
      {[["12:34","Adaeze Okonkwo","mentor","842 tokens","$0.013",false],["12:31","Ngozi Adeleke","mentor","512 tokens","cached",true],["12:28","Fatima Bello","advisor","1024 tokens","$0.015",false],["12:25","Blessing Eze","mentor","680 tokens","$0.010",false],["12:20","Chukwudi Eze","mentor","320 tokens","cached",true]].map(([t,u,tp,tk,c,cached],i)=><div key={i} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 0",borderBottom:i<4?"1px solid #F8F7FF":"none"}}>
        <div style={{fontSize:12,color:GR,width:40,flexShrink:0}}>{t}</div>
        <div style={{width:28,height:28,borderRadius:"50%",background:PL,display:"flex",alignItems:"center",justifyContent:"center",fontSize:14,flexShrink:0}}>🤖</div>
        <div style={{flex:1,minWidth:0}}><div style={{fontWeight:600,fontSize:13,color:DK}}>{u}</div><div style={{fontSize:11,color:GR}}>{tp} · {tk}</div></div>
        <span style={{fontSize:10,fontWeight:700,color:cached?G:RE,background:cached?"#ECFDF5":"#FEF2F2",borderRadius:20,padding:"3px 10px"}}>{cached?"⚡ Cached":c}</span>
      </div>)}
    </div>
  </div>);
  const AnnouncementsPage=()=>{
    const[form,setForm]=useState({title:"",message:"",target:"all",type:"info"});
    const[sent,setSent]=useState(false);
    const[announcements,setAnnouncements]=useState([{title:"Welcome to Talebis!",message:"Platform is now live. Start learning today.",target:"all",type:"info",date:"2024-08-29"},{title:"New Daily Challenges",message:"10 new challenges added this week.",target:"students",type:"success",date:"2024-08-28"}]);
    function sendAnnouncement(){if(!form.title||!form.message)return;setAnnouncements(a=>[{...form,date:new Date().toISOString().slice(0,10)},...a]);setForm({title:"",message:"",target:"all",type:"info"});setSent(true);setTimeout(()=>setSent(false),3000);}
    return(<div style={{flex:1,overflowY:"auto",padding:mob?14:24,background:BG}}>
      <h2 style={{fontWeight:900,fontSize:mob?18:22,color:DK,margin:"0 0 4px"}}>Announcements 📢</h2>
      <p style={{color:GR,fontSize:13,margin:"0 0 20px"}}>Send messages to your users</p>
      <div style={{display:"flex",gap:20,flexWrap:"wrap"}}>
        <div style={{flex:"1 1 300px",...card({padding:24})}}>
          <div style={{fontWeight:700,fontSize:15,color:DK,marginBottom:16}}>Compose Announcement</div>
          {sent&&<div style={{background:"#ECFDF5",border:"1px solid #A7F3D0",borderRadius:10,padding:"10px 14px",marginBottom:14,fontSize:13,color:G}}>✅ Sent successfully!</div>}
          {[["Title","title","e.g. New feature announcement"],["Message","message","Your announcement message..."]].map(([l,k,ph])=><div key={k} style={{marginBottom:12}}><label style={{fontSize:12,fontWeight:600,color:GR,display:"block",marginBottom:6}}>{l}</label>{k==="message"?<textarea value={form[k]} onChange={e=>setForm(f=>({...f,[k]:e.target.value}))} placeholder={ph} rows={4} style={{width:"100%",padding:"10px 14px",borderRadius:10,border:"1.5px solid #E0D9FF",fontSize:13,outline:"none",color:DK,boxSizing:"border-box",resize:"vertical"}}/>:<input value={form[k]} onChange={e=>setForm(f=>({...f,[k]:e.target.value}))} placeholder={ph} style={{width:"100%",padding:"10px 14px",borderRadius:10,border:"1.5px solid #E0D9FF",fontSize:13,outline:"none",color:DK,boxSizing:"border-box"}}/>}</div>)}
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:16}}>
            {[["Target","target",[["all","All Users"],["students","Students"],["employers","Employers"],["startups","Startups"],["premium","Premium Only"]]],["Type","type",[["info","ℹ️ Info"],["success","✅ Success"],["warning","⚠️ Warning"]]]].map(([l,k,opts])=><div key={k}><label style={{fontSize:12,fontWeight:600,color:GR,display:"block",marginBottom:6}}>{l}</label><select value={form[k]} onChange={e=>setForm(f=>({...f,[k]:e.target.value}))} style={{width:"100%",padding:"10px 12px",borderRadius:10,border:"1.5px solid #E0D9FF",fontSize:13,outline:"none",color:DK,background:"#fff",boxSizing:"border-box"}}>{opts.map(([v,lb])=><option key={v} value={v}>{lb}</option>)}</select></div>)}
          </div>
          <button onClick={sendAnnouncement} style={{width:"100%",background:`linear-gradient(135deg,${P},#5B21B6)`,color:"#fff",border:"none",borderRadius:12,padding:"12px",fontWeight:700,fontSize:14,cursor:"pointer"}}>Send Announcement 📢</button>
        </div>
        <div style={{flex:"1 1 260px",...card({padding:20})}}>
          <div style={{fontWeight:700,fontSize:15,color:DK,marginBottom:16}}>Sent Announcements</div>
          {announcements.map((a,i)=><div key={i} style={{padding:"12px 0",borderBottom:i<announcements.length-1?"1px solid #F8F7FF":"none"}}><div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}><span style={{fontWeight:600,fontSize:13,color:DK}}>{a.title}</span><span style={{fontSize:10,fontWeight:700,color:a.type==="info"?P:a.type==="success"?G:OR,background:a.type==="info"?PL:a.type==="success"?"#ECFDF5":"#FFFBEB",borderRadius:20,padding:"2px 8px"}}>{a.type}</span></div><div style={{fontSize:12,color:GR,marginBottom:6}}>{a.message}</div><div style={{fontSize:11,color:GR}}>{a.target} · {a.date}</div></div>)}
        </div>
      </div>
    </div>);
  };
  const AnalyticsPage=()=>(<div style={{flex:1,overflowY:"auto",padding:mob?14:24,background:BG}}>
    <h2 style={{fontWeight:900,fontSize:mob?18:22,color:DK,margin:"0 0 4px"}}>Analytics 📊</h2>
    <p style={{color:GR,fontSize:13,margin:"0 0 20px"}}>Platform performance metrics</p>
    <div style={{display:"grid",gridTemplateColumns:mob?"1fr":"1fr 1fr",gap:20}}>
      <div style={{...card({padding:20})}}>
        <div style={{fontWeight:700,fontSize:14,color:DK,marginBottom:16}}>Conversion Funnel</div>
        {[["Visited landing page",8420,100,"#E5E7EB"],["Signed up free",1247,14.8,P],["Upgraded to premium",312,3.7,OR]].map((r,i)=><div key={i} style={{marginBottom:14}}><div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}><span style={{fontSize:13,color:DK}}>{r[0]}</span><span style={{fontSize:13,fontWeight:700,color:DK}}>{r[1].toLocaleString()} ({r[2]}%)</span></div><div style={{height:10,background:"#F0EDFF",borderRadius:10,overflow:"hidden"}}><div style={{height:"100%",width:`${r[2]}%`,background:r[3],borderRadius:10}}/></div></div>)}
      </div>
      <div style={{...card({padding:20})}}>
        <div style={{fontWeight:700,fontSize:14,color:DK,marginBottom:16}}>Top Features Used</div>
        {[["🤖","AI Mentor Chat",2841,P],["📚","Learning Paths",1920,G],["🏗️","Projects",1540,OR],["🏆","Leaderboard",980,"#06B6D4"],["💼","Career Hub",620,"#8B5CF6"]].map((f,i)=><div key={i} style={{display:"flex",alignItems:"center",gap:12,padding:"8px 0",borderBottom:i<4?"1px solid #F8F7FF":"none"}}><span style={{fontSize:18}}>{f[0]}</span><div style={{flex:1}}><div style={{display:"flex",justifyContent:"space-between",marginBottom:4}}><span style={{fontSize:13,fontWeight:600,color:DK}}>{f[1]}</span><span style={{fontSize:12,color:GR}}>{f[2].toLocaleString()}</span></div><div style={{height:6,background:"#F0EDFF",borderRadius:6,overflow:"hidden"}}><div style={{height:"100%",width:`${(f[2]/2841)*100}%`,background:f[3],borderRadius:6}}/></div></div></div>)}
      </div>
      <div style={{...card({padding:20})}}>
        <div style={{fontWeight:700,fontSize:14,color:DK,marginBottom:16}}>Users by State</div>
        {[["Lagos",482,38.6],["Abuja",198,15.9],["Rivers",143,11.5],["Oyo",112,9.0],["Kano",87,7.0],["Others",225,18.0]].map((s,i)=><div key={i} style={{display:"flex",alignItems:"center",gap:12,padding:"8px 0",borderBottom:i<5?"1px solid #F8F7FF":"none"}}><span style={{fontSize:13,fontWeight:600,color:DK,width:80,flexShrink:0}}>{s[0]}</span><div style={{flex:1,height:8,background:"#F0EDFF",borderRadius:8,overflow:"hidden"}}><div style={{height:"100%",width:`${s[2]}%`,background:`linear-gradient(90deg,${P},${PM})`,borderRadius:8}}/></div><span style={{fontSize:12,color:GR,width:70,textAlign:"right",flexShrink:0}}>{s[1]} ({s[2]}%)</span></div>)}
      </div>
      <div style={{...card({padding:20})}}>
        <div style={{fontWeight:700,fontSize:14,color:DK,marginBottom:16}}>Retention Metrics</div>
        {[["Day 1 retention","78%",G],["Day 7 retention","52%",OR],["Day 30 retention","34%",P],["Premium churn","3.8%/mo",RE],["Avg session","14 mins",DK],["Sessions/week","4.2",DK]].map((r,i)=><div key={i} style={{display:"flex",justifyContent:"space-between",padding:"10px 0",borderBottom:i<5?"1px solid #F8F7FF":"none"}}><span style={{fontSize:13,color:DK}}>{r[0]}</span><span style={{fontSize:14,fontWeight:700,color:r[2]}}>{r[1]}</span></div>)}
      </div>
    </div>
  </div>);
  const SettingsPage=()=>{
    const[settings,setSettings]=useState({aiEnabled:true,freeLimit:3,premiumPrice:3000,maintenance:false,emails:true});
    const[saved,setSaved]=useState(false);
    function save(){setSaved(true);setTimeout(()=>setSaved(false),2000);}
    const toggle=(k)=>setSettings(s=>({...s,[k]:!s[k]}));
    const Toggle=({k})=>(<div onClick={()=>toggle(k)} style={{width:44,height:24,borderRadius:12,background:settings[k]?G:"#D1D5DB",position:"relative",cursor:"pointer",transition:"background 0.2s"}}><div style={{position:"absolute",top:2,left:settings[k]?22:2,width:20,height:20,borderRadius:"50%",background:"#fff",transition:"left 0.2s"}}/></div>);
    return(<div style={{flex:1,overflowY:"auto",padding:mob?14:24,background:BG}}>
      <h2 style={{fontWeight:900,fontSize:mob?18:22,color:DK,margin:"0 0 4px"}}>Settings ⚙️</h2>
      <p style={{color:GR,fontSize:13,margin:"0 0 20px"}}>Platform configuration</p>
      {saved&&<div style={{background:"#ECFDF5",border:"1px solid #A7F3D0",borderRadius:12,padding:"12px 18px",marginBottom:16,fontSize:14,color:G,fontWeight:600}}>✅ Settings saved!</div>}
      <div style={{display:"flex",flexDirection:"column",gap:16}}>
        <div style={{...card({padding:20})}}>
          <div style={{fontWeight:700,fontSize:14,color:DK,marginBottom:16}}>🤖 AI Settings</div>
          {[["AI Mentor Enabled","Turn off to save costs","aiEnabled"],["Email Notifications","Send welcome and upgrade emails","emails"]].map(([t,d,k])=><div key={k} style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}><div><div style={{fontWeight:600,fontSize:14,color:DK}}>{t}</div><div style={{fontSize:12,color:GR}}>{d}</div></div><Toggle k={k}/></div>)}
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}><div><div style={{fontWeight:600,fontSize:14,color:DK}}>Free AI Sessions/Day</div><div style={{fontSize:12,color:GR}}>Limit for free users</div></div><input type="number" value={settings.freeLimit} onChange={e=>setSettings(s=>({...s,freeLimit:parseInt(e.target.value)}))} style={{width:70,padding:"8px 12px",borderRadius:10,border:"1.5px solid #E0D9FF",fontSize:14,outline:"none",color:DK,textAlign:"center"}}/></div>
        </div>
        <div style={{...card({padding:20})}}>
          <div style={{fontWeight:700,fontSize:14,color:DK,marginBottom:16}}>💰 Pricing</div>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}><div><div style={{fontWeight:600,fontSize:14,color:DK}}>Premium Price (₦)</div><div style={{fontSize:12,color:GR}}>Monthly subscription</div></div><input type="number" value={settings.premiumPrice} onChange={e=>setSettings(s=>({...s,premiumPrice:parseInt(e.target.value)}))} style={{width:100,padding:"8px 12px",borderRadius:10,border:"1.5px solid #E0D9FF",fontSize:14,outline:"none",color:DK,textAlign:"center"}}/></div>
        </div>
        <div style={{...card({padding:20})}}>
          <div style={{fontWeight:700,fontSize:14,color:DK,marginBottom:16}}>🔧 System</div>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}><div><div style={{fontWeight:600,fontSize:14,color:DK}}>Maintenance Mode</div><div style={{fontSize:12,color:RE}}>⚠️ Takes platform offline</div></div><div onClick={()=>toggle("maintenance")} style={{width:44,height:24,borderRadius:12,background:settings.maintenance?RE:"#D1D5DB",position:"relative",cursor:"pointer",transition:"background 0.2s"}}><div style={{position:"absolute",top:2,left:settings.maintenance?22:2,width:20,height:20,borderRadius:"50%",background:"#fff",transition:"left 0.2s"}}/></div></div>
        </div>
        <button onClick={save} style={{background:`linear-gradient(135deg,${P},#5B21B6)`,color:"#fff",border:"none",borderRadius:12,padding:"14px",fontWeight:700,fontSize:15,cursor:"pointer",boxShadow:`0 4px 20px ${P}40`}}>Save All Settings ✓</button>
      </div>
    </div>);
  };
  const page=()=>{switch(active){case"Overview":{const El=Overview;return<El/>;} case"Users":{const El=UsersPage;return<El/>;} case"Subscriptions":{const El=SubscriptionsPage;return<El/>;} case"AI Monitor":{const El=AIMonitorPage;return<El/>;} case"Announcements":{const El=AnnouncementsPage;return<El/>;} case"Analytics":{const El=AnalyticsPage;return<El/>;} case"Settings":{const El=SettingsPage;return<El/>;} default:return<div style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",background:BG,flexDirection:"column",gap:12}}><div style={{fontSize:48}}>🚧</div><div style={{fontWeight:700,fontSize:16,color:DK}}>{active} coming soon</div></div>;}};
  return(<div style={{display:"flex",height:"100dvh",fontFamily:"'Inter',system-ui,sans-serif",overflow:"hidden",flexDirection:"column"}}>
    <div style={{display:"flex",flex:1,overflow:"hidden"}}>
      {sidebar}
      <div style={{flex:1,display:"flex",flexDirection:"column",overflow:"hidden"}}>
        <div style={{height:60,background:"#fff",borderBottom:"1px solid #F0EDFF",display:"flex",alignItems:"center",padding:`0 ${mob?12:24}px`,gap:12,flexShrink:0}}>
          {mob&&<button onClick={()=>setSidebarOpen(true)} style={{...btn("none",DK),fontSize:22}}>☰</button>}
          <div style={{fontWeight:700,fontSize:mob?15:18,color:DK}}>{active}</div>
          <div style={{flex:1}}/>
          <div style={{fontSize:12,color:GR}}>🟢 System Online</div>
        </div>
        {page()}
      </div>
    </div>
  </div>);
}
function AdminApp({onExit}){
  const[loggedIn,setLoggedIn]=useState(false);
  if(!loggedIn)return<AdminLogin onLogin={()=>setLoggedIn(true)}/>;
  return<AdminDash onExit={onExit}/>;
}

export default function App(){
  const{mob}=useBP();
  const[view,setView]=useState("landing");
  const[nav,setNav]=useState("Dashboard");
  const[sidebarOpen,setSidebarOpen]=useState(false);
  const[isPremium,setIsPremium]=useState(false);
  const[user,setUser]=useState(null);
  const[showModal,setShowModal]=useState(false);
  const[showAuth,setShowAuth]=useState(false);
  const[authTab,setAuthTab]=useState("login");
  useEffect(()=>{if(window.location.pathname==="/admin")setView("admin");const h=(e)=>{if(e.ctrlKey&&e.shiftKey&&e.key==="A")setView("admin");};window.addEventListener("keydown",h);return()=>window.removeEventListener("keydown",h);},[]);
  useEffect(()=>{
    async function checkSession(){
      const{data:{session}}=await supabase.auth.getSession();
      if(session?.user){
        const{data:profile}=await supabase.from("profiles").select("*").eq("id",session.user.id).single();
        const finalProfile={...profile,id:profile?.id||session.user.id,email:profile?.email||session.user.email};
        setUser({name:finalProfile.name,email:finalProfile.email,id:finalProfile.id,...finalProfile});
        setIsPremium(finalProfile.plan==="premium");
        if(finalProfile.portal==="employer")setView("employer");else if(finalProfile.portal==="startup")setView("startup");else setView("student");
      }
    }
    checkSession();
  },[]);
  function openLogin(){setAuthTab("login");setShowAuth(true);}
  function openSignup(){setAuthTab("signup");setShowAuth(true);}
  function onAuthSuccess({portal,name,email,profile}){
    setUser({name,email,id:profile?.id,...profile});
    if(profile?.plan==="premium")setIsPremium(true);
    setShowAuth(false);
    if(portal==="employer")setView("employer");else if(portal==="startup")setView("startup");else setView("student");
  }
  if(view==="admin")return<AdminApp onExit={()=>setView("landing")}/>;
  if(view==="employer")return<EmployerDash onSwitch={()=>setView("student")} onStudent={()=>setView("student")} onStartup={()=>setView("startup")}/>;
  if(view==="startup")return<StartupDash onSwitch={()=>setView("student")} onStudent={()=>setView("student")} onEmployer={()=>setView("employer")}/>;
  if(view==="student")return(<div style={{display:"flex",height:"100dvh",fontFamily:"'Inter',system-ui,sans-serif",overflow:"hidden",flexDirection:"column"}}>
    {showAuth&&<AuthModal defaultTab={authTab} onClose={()=>setShowAuth(false)} onSuccess={onAuthSuccess}/>}
    {showModal&&<UpgradeModal onClose={()=>setShowModal(false)} onSuccess={()=>{setIsPremium(true);setShowModal(false);}} user={user}/>}
    <div style={{display:"flex",flex:1,overflow:"hidden"}}>
      <StudentSidebar active={nav} setActive={setNav} open={sidebarOpen} setOpen={setSidebarOpen} isPremium={isPremium}/>
      <div style={{flex:1,display:"flex",flexDirection:"column",overflow:"hidden"}}>
        <TopBar onMenu={()=>setSidebarOpen(true)} isPremium={isPremium} onUpgrade={()=>setShowModal(true)}/>
        <PortalSwitcher current="student" onStudent={()=>{}} onEmployer={()=>setView("employer")} onStartup={()=>setView("startup")}/>
        {nav==="AI Mentor"?<AIMentorPage
  isPremium={isPremium}
  onUpgrade={()=>setShowModal(true)}
  userId={user?.id}
/>:nav==="XP & Rewards"?<XPRewardsPage/>:nav==="Career Hub"?<CareerHubPage isPremium={isPremium} onUpgrade={()=>setShowModal(true)}/>:<StudentDash isPremium={isPremium} onUpgrade={()=>setShowModal(true)} user={user}/>}
      </div>
    </div>
    {mob&&<div style={{display:"flex",background:"#fff",borderTop:"1px solid #F0EDFF",padding:"8px 0 4px",flexShrink:0}}>
      {[["⊞","Dashboard"],["📚","Learning Paths"],["🤖","AI Mentor"],["⭐","XP & Rewards"],["📁","Portfolio"]].map(([ic,lb])=><div key={lb} onClick={()=>setNav(lb)} style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",gap:3,cursor:"pointer",padding:"4px 0"}}><div style={{fontSize:20,filter:nav===lb?"none":"grayscale(1) opacity(0.4)"}}>{ic}</div><div style={{fontSize:9,fontWeight:600,color:nav===lb?P:GR}}>{lb.split(" ")[0]}</div></div>)}
    </div>}
  </div>);
  return(<div style={{fontFamily:"'Inter',system-ui,sans-serif",minHeight:"100dvh",background:"#fff"}}>
    {showAuth&&<AuthModal defaultTab={authTab} onClose={()=>setShowAuth(false)} onSuccess={onAuthSuccess}/>}
    {showModal&&<UpgradeModal onClose={()=>setShowModal(false)} onSuccess={()=>{setIsPremium(true);setShowModal(false);}} user={user}/>}
    <LandingNav onStudent={openSignup} onEmployer={openSignup} onStartup={openSignup} onLogin={openLogin}/>
    <Hero onStudent={openSignup}/>
    <ProblemSection/>
    <HowItWorks onStudent={openSignup}/>
    <PortalSelector onStudent={openSignup} onEmployer={()=>{setAuthTab("signup");setShowAuth(true);}} onStartup={()=>{setAuthTab("signup");setShowAuth(true);}}/>
    <StudentProofSection onStudent={openSignup}/>
    <EmployerSection onEmployer={()=>{setAuthTab("signup");setShowAuth(true);}}/>
    <Features/>
    <Pricing onUpgrade={()=>setShowModal(true)}/>
    <Trusted/>
    <CTA onStudent={openSignup}/>
  </div>);
}
